
      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire8661"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire8661"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("dCBbD", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")));
})(this, function(CryptoJS) {
    (function(Math1) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var Hasher = C_lib.Hasher;
        var C_algo = C.algo;
        // Initialization and round constants tables
        var H = [];
        var K = [];
        // Compute constants
        (function() {
            function isPrime(n) {
                var sqrtN = Math1.sqrt(n);
                for(var factor = 2; factor <= sqrtN; factor++){
                    if (!(n % factor)) return false;
                }
                return true;
            }
            function getFractionalBits(n) {
                return (n - (n | 0)) * 0x100000000 | 0;
            }
            var n = 2;
            var nPrime = 0;
            while(nPrime < 64){
                if (isPrime(n)) {
                    if (nPrime < 8) H[nPrime] = getFractionalBits(Math1.pow(n, 0.5));
                    K[nPrime] = getFractionalBits(Math1.pow(n, 1 / 3));
                    nPrime++;
                }
                n++;
            }
        })();
        // Reusable object
        var W = [];
        /**
	     * SHA-256 hash algorithm.
	     */ var SHA256 = C_algo.SHA256 = Hasher.extend({
            _doReset: function() {
                this._hash = new WordArray.init(H.slice(0));
            },
            _doProcessBlock: function(M, offset) {
                // Shortcut
                var H = this._hash.words;
                // Working variables
                var a = H[0];
                var b = H[1];
                var c = H[2];
                var d = H[3];
                var e = H[4];
                var f = H[5];
                var g = H[6];
                var h = H[7];
                // Computation
                for(var i = 0; i < 64; i++){
                    if (i < 16) W[i] = M[offset + i] | 0;
                    else {
                        var gamma0x = W[i - 15];
                        var gamma0 = (gamma0x << 25 | gamma0x >>> 7) ^ (gamma0x << 14 | gamma0x >>> 18) ^ gamma0x >>> 3;
                        var gamma1x = W[i - 2];
                        var gamma1 = (gamma1x << 15 | gamma1x >>> 17) ^ (gamma1x << 13 | gamma1x >>> 19) ^ gamma1x >>> 10;
                        W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16];
                    }
                    var ch = e & f ^ ~e & g;
                    var maj = a & b ^ a & c ^ b & c;
                    var sigma0 = (a << 30 | a >>> 2) ^ (a << 19 | a >>> 13) ^ (a << 10 | a >>> 22);
                    var sigma1 = (e << 26 | e >>> 6) ^ (e << 21 | e >>> 11) ^ (e << 7 | e >>> 25);
                    var t1 = h + sigma1 + ch + K[i] + W[i];
                    var t2 = sigma0 + maj;
                    h = g;
                    g = f;
                    f = e;
                    e = d + t1 | 0;
                    d = c;
                    c = b;
                    b = a;
                    a = t1 + t2 | 0;
                }
                // Intermediate hash value
                H[0] = H[0] + a | 0;
                H[1] = H[1] + b | 0;
                H[2] = H[2] + c | 0;
                H[3] = H[3] + d | 0;
                H[4] = H[4] + e | 0;
                H[5] = H[5] + f | 0;
                H[6] = H[6] + g | 0;
                H[7] = H[7] + h | 0;
            },
            _doFinalize: function() {
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var nBitsTotal = this._nDataBytes * 8;
                var nBitsLeft = data.sigBytes * 8;
                // Add padding
                dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = Math1.floor(nBitsTotal / 0x100000000);
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 15] = nBitsTotal;
                data.sigBytes = dataWords.length * 4;
                // Hash final blocks
                this._process();
                // Return final computed hash
                return this._hash;
            },
            clone: function() {
                var clone = Hasher.clone.call(this);
                clone._hash = this._hash.clone();
                return clone;
            }
        });
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA256('message');
	     *     var hash = CryptoJS.SHA256(wordArray);
	     */ C.SHA256 = Hasher._createHelper(SHA256);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA256(message, key);
	     */ C.HmacSHA256 = Hasher._createHmacHelper(SHA256);
    })(Math);
    return CryptoJS.SHA256;
});

});
parcelRegister("3OBZa", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory();
})(this, function() {
    /*globals window, global, require*/ /**
	 * CryptoJS core components.
	 */ var CryptoJS = CryptoJS || function(Math1, undefined) {
        var crypto;
        // Native crypto from window (Browser)
        if (typeof window !== 'undefined' && window.crypto) crypto = window.crypto;
        // Native crypto in web worker (Browser)
        if (typeof self !== 'undefined' && self.crypto) crypto = self.crypto;
        // Native crypto from worker
        if (typeof globalThis !== 'undefined' && globalThis.crypto) crypto = globalThis.crypto;
        // Native (experimental IE 11) crypto from window (Browser)
        if (!crypto && typeof window !== 'undefined' && window.msCrypto) crypto = window.msCrypto;
        // Native crypto from global (NodeJS)
        if (!crypto && typeof $parcel$global !== 'undefined' && $parcel$global.crypto) crypto = $parcel$global.crypto;
        // Native crypto import via require (NodeJS)
        if (!crypto && true) try {
            crypto = (parcelRequire("kjyEk"));
        } catch (err) {}
        /*
	     * Cryptographically secure pseudorandom number generator
	     *
	     * As Math.random() is cryptographically not safe to use
	     */ var cryptoSecureRandomInt = function() {
            if (crypto) {
                // Use getRandomValues method (Browser)
                if (typeof crypto.getRandomValues === 'function') try {
                    return crypto.getRandomValues(new Uint32Array(1))[0];
                } catch (err) {}
                // Use randomBytes method (NodeJS)
                if (typeof crypto.randomBytes === 'function') try {
                    return crypto.randomBytes(4).readInt32LE();
                } catch (err) {}
            }
            throw new Error('Native crypto module could not be used to get secure random number.');
        };
        /*
	     * Local polyfill of Object.create

	     */ var create = Object.create || function() {
            function F() {}
            return function(obj) {
                var subtype;
                F.prototype = obj;
                subtype = new F();
                F.prototype = null;
                return subtype;
            };
        }();
        /**
	     * CryptoJS namespace.
	     */ var C = {};
        /**
	     * Library namespace.
	     */ var C_lib = C.lib = {};
        /**
	     * Base object for prototypal inheritance.
	     */ var Base = C_lib.Base = function() {
            return {
                /**
	             * Creates a new object that inherits from this object.
	             *
	             * @param {Object} overrides Properties to copy into the new object.
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         field: 'value',
	             *
	             *         method: function () {
	             *         }
	             *     });
	             */ extend: function(overrides) {
                    // Spawn
                    var subtype = create(this);
                    // Augment
                    if (overrides) subtype.mixIn(overrides);
                    // Create default initializer
                    if (!subtype.hasOwnProperty('init') || this.init === subtype.init) subtype.init = function() {
                        subtype.$super.init.apply(this, arguments);
                    };
                    // Initializer's prototype is the subtype object
                    subtype.init.prototype = subtype;
                    // Reference supertype
                    subtype.$super = this;
                    return subtype;
                },
                /**
	             * Extends this object and runs the init method.
	             * Arguments to create() will be passed to init().
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var instance = MyType.create();
	             */ create: function() {
                    var instance = this.extend();
                    instance.init.apply(instance, arguments);
                    return instance;
                },
                /**
	             * Initializes a newly created object.
	             * Override this method to add some logic when your objects are created.
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         init: function () {
	             *             // ...
	             *         }
	             *     });
	             */ init: function() {},
                /**
	             * Copies properties into this object.
	             *
	             * @param {Object} properties The properties to mix in.
	             *
	             * @example
	             *
	             *     MyType.mixIn({
	             *         field: 'value'
	             *     });
	             */ mixIn: function(properties) {
                    for(var propertyName in properties)if (properties.hasOwnProperty(propertyName)) this[propertyName] = properties[propertyName];
                    // IE won't copy toString using the loop above
                    if (properties.hasOwnProperty('toString')) this.toString = properties.toString;
                },
                /**
	             * Creates a copy of this object.
	             *
	             * @return {Object} The clone.
	             *
	             * @example
	             *
	             *     var clone = instance.clone();
	             */ clone: function() {
                    return this.init.prototype.extend(this);
                }
            };
        }();
        /**
	     * An array of 32-bit words.
	     *
	     * @property {Array} words The array of 32-bit words.
	     * @property {number} sigBytes The number of significant bytes in this word array.
	     */ var WordArray = C_lib.WordArray = Base.extend({
            /**
	         * Initializes a newly created word array.
	         *
	         * @param {Array} words (Optional) An array of 32-bit words.
	         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.create();
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
	         */ init: function(words, sigBytes) {
                words = this.words = words || [];
                if (sigBytes != undefined) this.sigBytes = sigBytes;
                else this.sigBytes = words.length * 4;
            },
            /**
	         * Converts this word array to a string.
	         *
	         * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
	         *
	         * @return {string} The stringified word array.
	         *
	         * @example
	         *
	         *     var string = wordArray + '';
	         *     var string = wordArray.toString();
	         *     var string = wordArray.toString(CryptoJS.enc.Utf8);
	         */ toString: function(encoder) {
                return (encoder || Hex).stringify(this);
            },
            /**
	         * Concatenates a word array to this word array.
	         *
	         * @param {WordArray} wordArray The word array to append.
	         *
	         * @return {WordArray} This word array.
	         *
	         * @example
	         *
	         *     wordArray1.concat(wordArray2);
	         */ concat: function(wordArray) {
                // Shortcuts
                var thisWords = this.words;
                var thatWords = wordArray.words;
                var thisSigBytes = this.sigBytes;
                var thatSigBytes = wordArray.sigBytes;
                // Clamp excess bits
                this.clamp();
                // Concat
                if (thisSigBytes % 4) // Copy one byte at a time
                for(var i = 0; i < thatSigBytes; i++){
                    var thatByte = thatWords[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    thisWords[thisSigBytes + i >>> 2] |= thatByte << 24 - (thisSigBytes + i) % 4 * 8;
                }
                else // Copy one word at a time
                for(var j = 0; j < thatSigBytes; j += 4)thisWords[thisSigBytes + j >>> 2] = thatWords[j >>> 2];
                this.sigBytes += thatSigBytes;
                // Chainable
                return this;
            },
            /**
	         * Removes insignificant bits.
	         *
	         * @example
	         *
	         *     wordArray.clamp();
	         */ clamp: function() {
                // Shortcuts
                var words = this.words;
                var sigBytes = this.sigBytes;
                // Clamp
                words[sigBytes >>> 2] &= 0xffffffff << 32 - sigBytes % 4 * 8;
                words.length = Math1.ceil(sigBytes / 4);
            },
            /**
	         * Creates a copy of this word array.
	         *
	         * @return {WordArray} The clone.
	         *
	         * @example
	         *
	         *     var clone = wordArray.clone();
	         */ clone: function() {
                var clone = Base.clone.call(this);
                clone.words = this.words.slice(0);
                return clone;
            },
            /**
	         * Creates a word array filled with random bytes.
	         *
	         * @param {number} nBytes The number of random bytes to generate.
	         *
	         * @return {WordArray} The random word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.random(16);
	         */ random: function(nBytes) {
                var words = [];
                for(var i = 0; i < nBytes; i += 4)words.push(cryptoSecureRandomInt());
                return new WordArray.init(words, nBytes);
            }
        });
        /**
	     * Encoder namespace.
	     */ var C_enc = C.enc = {};
        /**
	     * Hex encoding strategy.
	     */ var Hex = C_enc.Hex = {
            /**
	         * Converts a word array to a hex string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The hex string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                // Convert
                var hexChars = [];
                for(var i = 0; i < sigBytes; i++){
                    var bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    hexChars.push((bite >>> 4).toString(16));
                    hexChars.push((bite & 0x0f).toString(16));
                }
                return hexChars.join('');
            },
            /**
	         * Converts a hex string to a word array.
	         *
	         * @param {string} hexStr The hex string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
	         */ parse: function(hexStr) {
                // Shortcut
                var hexStrLength = hexStr.length;
                // Convert
                var words = [];
                for(var i = 0; i < hexStrLength; i += 2)words[i >>> 3] |= parseInt(hexStr.substr(i, 2), 16) << 24 - i % 8 * 4;
                return new WordArray.init(words, hexStrLength / 2);
            }
        };
        /**
	     * Latin1 encoding strategy.
	     */ var Latin1 = C_enc.Latin1 = {
            /**
	         * Converts a word array to a Latin1 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Latin1 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                // Convert
                var latin1Chars = [];
                for(var i = 0; i < sigBytes; i++){
                    var bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    latin1Chars.push(String.fromCharCode(bite));
                }
                return latin1Chars.join('');
            },
            /**
	         * Converts a Latin1 string to a word array.
	         *
	         * @param {string} latin1Str The Latin1 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
	         */ parse: function(latin1Str) {
                // Shortcut
                var latin1StrLength = latin1Str.length;
                // Convert
                var words = [];
                for(var i = 0; i < latin1StrLength; i++)words[i >>> 2] |= (latin1Str.charCodeAt(i) & 0xff) << 24 - i % 4 * 8;
                return new WordArray.init(words, latin1StrLength);
            }
        };
        /**
	     * UTF-8 encoding strategy.
	     */ var Utf8 = C_enc.Utf8 = {
            /**
	         * Converts a word array to a UTF-8 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-8 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
	         */ stringify: function(wordArray) {
                try {
                    return decodeURIComponent(escape(Latin1.stringify(wordArray)));
                } catch (e) {
                    throw new Error('Malformed UTF-8 data');
                }
            },
            /**
	         * Converts a UTF-8 string to a word array.
	         *
	         * @param {string} utf8Str The UTF-8 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
	         */ parse: function(utf8Str) {
                return Latin1.parse(unescape(encodeURIComponent(utf8Str)));
            }
        };
        /**
	     * Abstract buffered block algorithm template.
	     *
	     * The property blockSize must be implemented in a concrete subtype.
	     *
	     * @property {number} _minBufferSize The number of blocks that should be kept unprocessed in the buffer. Default: 0
	     */ var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm = Base.extend({
            /**
	         * Resets this block algorithm's data buffer to its initial state.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm.reset();
	         */ reset: function() {
                // Initial values
                this._data = new WordArray.init();
                this._nDataBytes = 0;
            },
            /**
	         * Adds new data to this block algorithm's buffer.
	         *
	         * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm._append('data');
	         *     bufferedBlockAlgorithm._append(wordArray);
	         */ _append: function(data) {
                // Convert string to WordArray, else assume WordArray already
                if (typeof data == 'string') data = Utf8.parse(data);
                // Append
                this._data.concat(data);
                this._nDataBytes += data.sigBytes;
            },
            /**
	         * Processes available data blocks.
	         *
	         * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
	         *
	         * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
	         *
	         * @return {WordArray} The processed data.
	         *
	         * @example
	         *
	         *     var processedData = bufferedBlockAlgorithm._process();
	         *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
	         */ _process: function(doFlush) {
                var processedWords;
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var dataSigBytes = data.sigBytes;
                var blockSize = this.blockSize;
                var blockSizeBytes = blockSize * 4;
                // Count blocks ready
                var nBlocksReady = dataSigBytes / blockSizeBytes;
                if (doFlush) // Round up to include partial blocks
                nBlocksReady = Math1.ceil(nBlocksReady);
                else // Round down to include only full blocks,
                // less the number of blocks that must remain in the buffer
                nBlocksReady = Math1.max((nBlocksReady | 0) - this._minBufferSize, 0);
                // Count words ready
                var nWordsReady = nBlocksReady * blockSize;
                // Count bytes ready
                var nBytesReady = Math1.min(nWordsReady * 4, dataSigBytes);
                // Process blocks
                if (nWordsReady) {
                    for(var offset = 0; offset < nWordsReady; offset += blockSize)// Perform concrete-algorithm logic
                    this._doProcessBlock(dataWords, offset);
                    // Remove processed words
                    processedWords = dataWords.splice(0, nWordsReady);
                    data.sigBytes -= nBytesReady;
                }
                // Return processed words
                return new WordArray.init(processedWords, nBytesReady);
            },
            /**
	         * Creates a copy of this object.
	         *
	         * @return {Object} The clone.
	         *
	         * @example
	         *
	         *     var clone = bufferedBlockAlgorithm.clone();
	         */ clone: function() {
                var clone = Base.clone.call(this);
                clone._data = this._data.clone();
                return clone;
            },
            _minBufferSize: 0
        });
        /**
	     * Abstract hasher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this hasher operates on. Default: 16 (512 bits)
	     */ var Hasher = C_lib.Hasher = BufferedBlockAlgorithm.extend({
            /**
	         * Configuration options.
	         */ cfg: Base.extend(),
            /**
	         * Initializes a newly created hasher.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
	         *
	         * @example
	         *
	         *     var hasher = CryptoJS.algo.SHA256.create();
	         */ init: function(cfg) {
                // Apply config defaults
                this.cfg = this.cfg.extend(cfg);
                // Set initial values
                this.reset();
            },
            /**
	         * Resets this hasher to its initial state.
	         *
	         * @example
	         *
	         *     hasher.reset();
	         */ reset: function() {
                // Reset data buffer
                BufferedBlockAlgorithm.reset.call(this);
                // Perform concrete-hasher logic
                this._doReset();
            },
            /**
	         * Updates this hasher with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {Hasher} This hasher.
	         *
	         * @example
	         *
	         *     hasher.update('message');
	         *     hasher.update(wordArray);
	         */ update: function(messageUpdate) {
                // Append
                this._append(messageUpdate);
                // Update the hash
                this._process();
                // Chainable
                return this;
            },
            /**
	         * Finalizes the hash computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The hash.
	         *
	         * @example
	         *
	         *     var hash = hasher.finalize();
	         *     var hash = hasher.finalize('message');
	         *     var hash = hasher.finalize(wordArray);
	         */ finalize: function(messageUpdate) {
                // Final message update
                if (messageUpdate) this._append(messageUpdate);
                // Perform concrete-hasher logic
                var hash = this._doFinalize();
                return hash;
            },
            blockSize: 16,
            /**
	         * Creates a shortcut function to a hasher's object interface.
	         *
	         * @param {Hasher} hasher The hasher to create a helper for.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
	         */ _createHelper: function(hasher) {
                return function(message, cfg) {
                    return new hasher.init(cfg).finalize(message);
                };
            },
            /**
	         * Creates a shortcut function to the HMAC's object interface.
	         *
	         * @param {Hasher} hasher The hasher to use in this HMAC helper.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
	         */ _createHmacHelper: function(hasher) {
                return function(message, key) {
                    return new C_algo.HMAC.init(hasher, key).finalize(message);
                };
            }
        });
        /**
	     * Algorithm namespace.
	     */ var C_algo = C.algo = {};
        return C;
    }(Math);
    return CryptoJS;
});

});
parcelRegister("kjyEk", function(module, exports) {
"use strict";

});



parcelRegister("33Dov", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var C_enc = C.enc;
        /**
	     * Base64 encoding strategy.
	     */ var Base64 = C_enc.Base64 = {
            /**
	         * Converts a word array to a Base64 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Base64 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var base64String = CryptoJS.enc.Base64.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                var map = this._map;
                // Clamp excess bits
                wordArray.clamp();
                // Convert
                var base64Chars = [];
                for(var i = 0; i < sigBytes; i += 3){
                    var byte1 = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    var byte2 = words[i + 1 >>> 2] >>> 24 - (i + 1) % 4 * 8 & 0xff;
                    var byte3 = words[i + 2 >>> 2] >>> 24 - (i + 2) % 4 * 8 & 0xff;
                    var triplet = byte1 << 16 | byte2 << 8 | byte3;
                    for(var j = 0; j < 4 && i + j * 0.75 < sigBytes; j++)base64Chars.push(map.charAt(triplet >>> 6 * (3 - j) & 0x3f));
                }
                // Add padding
                var paddingChar = map.charAt(64);
                if (paddingChar) while(base64Chars.length % 4)base64Chars.push(paddingChar);
                return base64Chars.join('');
            },
            /**
	         * Converts a Base64 string to a word array.
	         *
	         * @param {string} base64Str The Base64 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Base64.parse(base64String);
	         */ parse: function(base64Str) {
                // Shortcuts
                var base64StrLength = base64Str.length;
                var map = this._map;
                var reverseMap = this._reverseMap;
                if (!reverseMap) {
                    reverseMap = this._reverseMap = [];
                    for(var j = 0; j < map.length; j++)reverseMap[map.charCodeAt(j)] = j;
                }
                // Ignore padding
                var paddingChar = map.charAt(64);
                if (paddingChar) {
                    var paddingIndex = base64Str.indexOf(paddingChar);
                    if (paddingIndex !== -1) base64StrLength = paddingIndex;
                }
                // Convert
                return parseLoop(base64Str, base64StrLength, reverseMap);
            },
            _map: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='
        };
        function parseLoop(base64Str, base64StrLength, reverseMap) {
            var words = [];
            var nBytes = 0;
            for(var i = 0; i < base64StrLength; i++)if (i % 4) {
                var bits1 = reverseMap[base64Str.charCodeAt(i - 1)] << i % 4 * 2;
                var bits2 = reverseMap[base64Str.charCodeAt(i)] >>> 6 - i % 4 * 2;
                var bitsCombined = bits1 | bits2;
                words[nBytes >>> 2] |= bitsCombined << 24 - nBytes % 4 * 8;
                nBytes++;
            }
            return WordArray.create(words, nBytes);
        }
    })();
    return CryptoJS.enc.Base64;
});

});

parcelRegister("dOqqi", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")));
})(this, function(CryptoJS) {
    (function() {
        // Check if typed arrays are supported
        if (typeof ArrayBuffer != 'function') return;
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        // Reference original init
        var superInit = WordArray.init;
        // Augment WordArray.init to handle typed arrays
        var subInit = WordArray.init = function(typedArray) {
            // Convert buffers to uint8
            if (typedArray instanceof ArrayBuffer) typedArray = new Uint8Array(typedArray);
            // Convert other array views to uint8
            if (typedArray instanceof Int8Array || typeof Uint8ClampedArray !== "undefined" && typedArray instanceof Uint8ClampedArray || typedArray instanceof Int16Array || typedArray instanceof Uint16Array || typedArray instanceof Int32Array || typedArray instanceof Uint32Array || typedArray instanceof Float32Array || typedArray instanceof Float64Array) typedArray = new Uint8Array(typedArray.buffer, typedArray.byteOffset, typedArray.byteLength);
            // Handle Uint8Array
            if (typedArray instanceof Uint8Array) {
                // Shortcut
                var typedArrayByteLength = typedArray.byteLength;
                // Extract bytes
                var words = [];
                for(var i = 0; i < typedArrayByteLength; i++)words[i >>> 2] |= typedArray[i] << 24 - i % 4 * 8;
                // Initialize this word array
                superInit.call(this, words, typedArrayByteLength);
            } else // Else call normal init
            superInit.apply(this, arguments);
        };
        subInit.prototype = WordArray;
    })();
    return CryptoJS.lib.WordArray;
});

});

/**
* (c) Iconify
*
* For the full copyright and license information, please view the license.txt
* files at https://github.com/iconify/iconify
*
* Licensed under MIT.
*
* @license MIT
* @version 2.3.0
*/ const $51b824d77c6dc314$var$defaultIconDimensions = Object.freeze({
    left: 0,
    top: 0,
    width: 16,
    height: 16
});
const $51b824d77c6dc314$var$defaultIconTransformations = Object.freeze({
    rotate: 0,
    vFlip: false,
    hFlip: false
});
const $51b824d77c6dc314$var$defaultIconProps = Object.freeze({
    ...$51b824d77c6dc314$var$defaultIconDimensions,
    ...$51b824d77c6dc314$var$defaultIconTransformations
});
const $51b824d77c6dc314$var$defaultExtendedIconProps = Object.freeze({
    ...$51b824d77c6dc314$var$defaultIconProps,
    body: "",
    hidden: false
});
const $51b824d77c6dc314$var$defaultIconSizeCustomisations = Object.freeze({
    width: null,
    height: null
});
const $51b824d77c6dc314$var$defaultIconCustomisations = Object.freeze({
    // Dimensions
    ...$51b824d77c6dc314$var$defaultIconSizeCustomisations,
    // Transformations
    ...$51b824d77c6dc314$var$defaultIconTransformations
});
function $51b824d77c6dc314$var$rotateFromString(value, defaultValue = 0) {
    const units = value.replace(/^-?[0-9.]*/, "");
    function cleanup(value2) {
        while(value2 < 0)value2 += 4;
        return value2 % 4;
    }
    if (units === "") {
        const num = parseInt(value);
        return isNaN(num) ? 0 : cleanup(num);
    } else if (units !== value) {
        let split = 0;
        switch(units){
            case "%":
                split = 25;
                break;
            case "deg":
                split = 90;
        }
        if (split) {
            let num = parseFloat(value.slice(0, value.length - units.length));
            if (isNaN(num)) return 0;
            num = num / split;
            return num % 1 === 0 ? cleanup(num) : 0;
        }
    }
    return defaultValue;
}
const $51b824d77c6dc314$var$separator = /[\s,]+/;
function $51b824d77c6dc314$var$flipFromString(custom, flip) {
    flip.split($51b824d77c6dc314$var$separator).forEach((str)=>{
        const value = str.trim();
        switch(value){
            case "horizontal":
                custom.hFlip = true;
                break;
            case "vertical":
                custom.vFlip = true;
                break;
        }
    });
}
const $51b824d77c6dc314$var$defaultCustomisations = {
    ...$51b824d77c6dc314$var$defaultIconCustomisations,
    preserveAspectRatio: ''
};
/**
 * Get customisations
 */ function $51b824d77c6dc314$var$getCustomisations(node) {
    const customisations = {
        ...$51b824d77c6dc314$var$defaultCustomisations
    };
    const attr = (key, def)=>node.getAttribute(key) || def;
    // Dimensions
    customisations.width = attr('width', null);
    customisations.height = attr('height', null);
    // Rotation
    customisations.rotate = $51b824d77c6dc314$var$rotateFromString(attr('rotate', ''));
    // Flip
    $51b824d77c6dc314$var$flipFromString(customisations, attr('flip', ''));
    // SVG attributes
    customisations.preserveAspectRatio = attr('preserveAspectRatio', attr('preserveaspectratio', ''));
    return customisations;
}
/**
 * Check if customisations have been updated
 */ function $51b824d77c6dc314$var$haveCustomisationsChanged(value1, value2) {
    for(const key in $51b824d77c6dc314$var$defaultCustomisations){
        if (value1[key] !== value2[key]) return true;
    }
    return false;
}
const $51b824d77c6dc314$var$matchIconName = /^[a-z0-9]+(-[a-z0-9]+)*$/;
const $51b824d77c6dc314$var$stringToIcon = (value, validate, allowSimpleName, provider = "")=>{
    const colonSeparated = value.split(":");
    if (value.slice(0, 1) === "@") {
        if (colonSeparated.length < 2 || colonSeparated.length > 3) return null;
        provider = colonSeparated.shift().slice(1);
    }
    if (colonSeparated.length > 3 || !colonSeparated.length) return null;
    if (colonSeparated.length > 1) {
        const name2 = colonSeparated.pop();
        const prefix = colonSeparated.pop();
        const result = {
            // Allow provider without '@': "provider:prefix:name"
            provider: colonSeparated.length > 0 ? colonSeparated[0] : provider,
            prefix: prefix,
            name: name2
        };
        return validate && !$51b824d77c6dc314$var$validateIconName(result) ? null : result;
    }
    const name = colonSeparated[0];
    const dashSeparated = name.split("-");
    if (dashSeparated.length > 1) {
        const result = {
            provider: provider,
            prefix: dashSeparated.shift(),
            name: dashSeparated.join("-")
        };
        return validate && !$51b824d77c6dc314$var$validateIconName(result) ? null : result;
    }
    if (allowSimpleName && provider === "") {
        const result = {
            provider: provider,
            prefix: "",
            name: name
        };
        return validate && !$51b824d77c6dc314$var$validateIconName(result, allowSimpleName) ? null : result;
    }
    return null;
};
const $51b824d77c6dc314$var$validateIconName = (icon, allowSimpleName)=>{
    if (!icon) return false;
    return !!// Check name: cannot be empty
    ((allowSimpleName && icon.prefix === "" || !!icon.prefix) && !!icon.name);
};
function $51b824d77c6dc314$var$mergeIconTransformations(obj1, obj2) {
    const result = {};
    if (!obj1.hFlip !== !obj2.hFlip) result.hFlip = true;
    if (!obj1.vFlip !== !obj2.vFlip) result.vFlip = true;
    const rotate = ((obj1.rotate || 0) + (obj2.rotate || 0)) % 4;
    if (rotate) result.rotate = rotate;
    return result;
}
function $51b824d77c6dc314$var$mergeIconData(parent, child) {
    const result = $51b824d77c6dc314$var$mergeIconTransformations(parent, child);
    for(const key in $51b824d77c6dc314$var$defaultExtendedIconProps){
        if (key in $51b824d77c6dc314$var$defaultIconTransformations) {
            if (key in parent && !(key in result)) result[key] = $51b824d77c6dc314$var$defaultIconTransformations[key];
        } else if (key in child) result[key] = child[key];
        else if (key in parent) result[key] = parent[key];
    }
    return result;
}
function $51b824d77c6dc314$var$getIconsTree(data, names) {
    const icons = data.icons;
    const aliases = data.aliases || /* @__PURE__ */ Object.create(null);
    const resolved = /* @__PURE__ */ Object.create(null);
    function resolve(name) {
        if (icons[name]) return resolved[name] = [];
        if (!(name in resolved)) {
            resolved[name] = null;
            const parent = aliases[name] && aliases[name].parent;
            const value = parent && resolve(parent);
            if (value) resolved[name] = [
                parent
            ].concat(value);
        }
        return resolved[name];
    }
    Object.keys(icons).concat(Object.keys(aliases)).forEach(resolve);
    return resolved;
}
function $51b824d77c6dc314$var$internalGetIconData(data, name, tree) {
    const icons = data.icons;
    const aliases = data.aliases || /* @__PURE__ */ Object.create(null);
    let currentProps = {};
    function parse(name2) {
        currentProps = $51b824d77c6dc314$var$mergeIconData(icons[name2] || aliases[name2], currentProps);
    }
    parse(name);
    tree.forEach(parse);
    return $51b824d77c6dc314$var$mergeIconData(data, currentProps);
}
function $51b824d77c6dc314$var$parseIconSet(data, callback) {
    const names = [];
    if (typeof data !== "object" || typeof data.icons !== "object") return names;
    if (data.not_found instanceof Array) data.not_found.forEach((name)=>{
        callback(name, null);
        names.push(name);
    });
    const tree = $51b824d77c6dc314$var$getIconsTree(data);
    for(const name in tree){
        const item = tree[name];
        if (item) {
            callback(name, $51b824d77c6dc314$var$internalGetIconData(data, name, item));
            names.push(name);
        }
    }
    return names;
}
const $51b824d77c6dc314$var$optionalPropertyDefaults = {
    provider: "",
    aliases: {},
    not_found: {},
    ...$51b824d77c6dc314$var$defaultIconDimensions
};
function $51b824d77c6dc314$var$checkOptionalProps(item, defaults) {
    for(const prop in defaults){
        if (prop in item && typeof item[prop] !== typeof defaults[prop]) return false;
    }
    return true;
}
function $51b824d77c6dc314$var$quicklyValidateIconSet(obj) {
    if (typeof obj !== "object" || obj === null) return null;
    const data = obj;
    if (typeof data.prefix !== "string" || !obj.icons || typeof obj.icons !== "object") return null;
    if (!$51b824d77c6dc314$var$checkOptionalProps(obj, $51b824d77c6dc314$var$optionalPropertyDefaults)) return null;
    const icons = data.icons;
    for(const name in icons){
        const icon = icons[name];
        if (// Name cannot be empty
        !name || // Must have body
        typeof icon.body !== "string" || // Check other props
        !$51b824d77c6dc314$var$checkOptionalProps(icon, $51b824d77c6dc314$var$defaultExtendedIconProps)) return null;
    }
    const aliases = data.aliases || /* @__PURE__ */ Object.create(null);
    for(const name in aliases){
        const icon = aliases[name];
        const parent = icon.parent;
        if (// Name cannot be empty
        !name || // Parent must be set and point to existing icon
        typeof parent !== "string" || !icons[parent] && !aliases[parent] || // Check other props
        !$51b824d77c6dc314$var$checkOptionalProps(icon, $51b824d77c6dc314$var$defaultExtendedIconProps)) return null;
    }
    return data;
}
const $51b824d77c6dc314$var$dataStorage = /* @__PURE__ */ Object.create(null);
function $51b824d77c6dc314$var$newStorage(provider, prefix) {
    return {
        provider: provider,
        prefix: prefix,
        icons: /* @__PURE__ */ Object.create(null),
        missing: /* @__PURE__ */ new Set()
    };
}
function $51b824d77c6dc314$var$getStorage(provider, prefix) {
    const providerStorage = $51b824d77c6dc314$var$dataStorage[provider] || ($51b824d77c6dc314$var$dataStorage[provider] = /* @__PURE__ */ Object.create(null));
    return providerStorage[prefix] || (providerStorage[prefix] = $51b824d77c6dc314$var$newStorage(provider, prefix));
}
function $51b824d77c6dc314$var$addIconSet(storage, data) {
    if (!$51b824d77c6dc314$var$quicklyValidateIconSet(data)) return [];
    return $51b824d77c6dc314$var$parseIconSet(data, (name, icon)=>{
        if (icon) storage.icons[name] = icon;
        else storage.missing.add(name);
    });
}
function $51b824d77c6dc314$var$addIconToStorage(storage, name, icon) {
    try {
        if (typeof icon.body === "string") {
            storage.icons[name] = {
                ...icon
            };
            return true;
        }
    } catch (err) {}
    return false;
}
function $51b824d77c6dc314$var$listIcons$1(provider, prefix) {
    let allIcons = [];
    const providers = typeof provider === "string" ? [
        provider
    ] : Object.keys($51b824d77c6dc314$var$dataStorage);
    providers.forEach((provider2)=>{
        const prefixes = typeof provider2 === "string" && typeof prefix === "string" ? [
            prefix
        ] : Object.keys($51b824d77c6dc314$var$dataStorage[provider2] || {});
        prefixes.forEach((prefix2)=>{
            const storage = $51b824d77c6dc314$var$getStorage(provider2, prefix2);
            allIcons = allIcons.concat(Object.keys(storage.icons).map((name)=>(provider2 !== "" ? "@" + provider2 + ":" : "") + prefix2 + ":" + name));
        });
    });
    return allIcons;
}
let $51b824d77c6dc314$var$simpleNames = false;
function $51b824d77c6dc314$var$allowSimpleNames(allow) {
    if (typeof allow === "boolean") $51b824d77c6dc314$var$simpleNames = allow;
    return $51b824d77c6dc314$var$simpleNames;
}
function $51b824d77c6dc314$var$getIconData(name) {
    const icon = typeof name === "string" ? $51b824d77c6dc314$var$stringToIcon(name, true, $51b824d77c6dc314$var$simpleNames) : name;
    if (icon) {
        const storage = $51b824d77c6dc314$var$getStorage(icon.provider, icon.prefix);
        const iconName = icon.name;
        return storage.icons[iconName] || (storage.missing.has(iconName) ? null : void 0);
    }
}
function $51b824d77c6dc314$var$addIcon$1(name, data) {
    const icon = $51b824d77c6dc314$var$stringToIcon(name, true, $51b824d77c6dc314$var$simpleNames);
    if (!icon) return false;
    const storage = $51b824d77c6dc314$var$getStorage(icon.provider, icon.prefix);
    if (data) return $51b824d77c6dc314$var$addIconToStorage(storage, icon.name, data);
    else {
        storage.missing.add(icon.name);
        return true;
    }
}
function $51b824d77c6dc314$var$addCollection$1(data, provider) {
    if (typeof data !== "object") return false;
    if (typeof provider !== "string") provider = data.provider || "";
    if ($51b824d77c6dc314$var$simpleNames && !provider && !data.prefix) {
        let added = false;
        if ($51b824d77c6dc314$var$quicklyValidateIconSet(data)) {
            data.prefix = "";
            $51b824d77c6dc314$var$parseIconSet(data, (name, icon)=>{
                if ($51b824d77c6dc314$var$addIcon$1(name, icon)) added = true;
            });
        }
        return added;
    }
    const prefix = data.prefix;
    if (!$51b824d77c6dc314$var$validateIconName({
        provider: provider,
        prefix: prefix,
        name: "a"
    })) return false;
    const storage = $51b824d77c6dc314$var$getStorage(provider, prefix);
    return !!$51b824d77c6dc314$var$addIconSet(storage, data);
}
function $51b824d77c6dc314$var$iconLoaded$1(name) {
    return !!$51b824d77c6dc314$var$getIconData(name);
}
function $51b824d77c6dc314$var$getIcon$1(name) {
    const result = $51b824d77c6dc314$var$getIconData(name);
    return result ? {
        ...$51b824d77c6dc314$var$defaultIconProps,
        ...result
    } : result;
}
function $51b824d77c6dc314$var$sortIcons(icons) {
    const result = {
        loaded: [],
        missing: [],
        pending: []
    };
    const storage = /* @__PURE__ */ Object.create(null);
    icons.sort((a, b)=>{
        if (a.provider !== b.provider) return a.provider.localeCompare(b.provider);
        if (a.prefix !== b.prefix) return a.prefix.localeCompare(b.prefix);
        return a.name.localeCompare(b.name);
    });
    let lastIcon = {
        provider: "",
        prefix: "",
        name: ""
    };
    icons.forEach((icon)=>{
        if (lastIcon.name === icon.name && lastIcon.prefix === icon.prefix && lastIcon.provider === icon.provider) return;
        lastIcon = icon;
        const provider = icon.provider;
        const prefix = icon.prefix;
        const name = icon.name;
        const providerStorage = storage[provider] || (storage[provider] = /* @__PURE__ */ Object.create(null));
        const localStorage = providerStorage[prefix] || (providerStorage[prefix] = $51b824d77c6dc314$var$getStorage(provider, prefix));
        let list;
        if (name in localStorage.icons) list = result.loaded;
        else if (prefix === "" || localStorage.missing.has(name)) list = result.missing;
        else list = result.pending;
        const item = {
            provider: provider,
            prefix: prefix,
            name: name
        };
        list.push(item);
    });
    return result;
}
function $51b824d77c6dc314$var$removeCallback(storages, id) {
    storages.forEach((storage)=>{
        const items = storage.loaderCallbacks;
        if (items) storage.loaderCallbacks = items.filter((row)=>row.id !== id);
    });
}
function $51b824d77c6dc314$var$updateCallbacks(storage) {
    if (!storage.pendingCallbacksFlag) {
        storage.pendingCallbacksFlag = true;
        setTimeout(()=>{
            storage.pendingCallbacksFlag = false;
            const items = storage.loaderCallbacks ? storage.loaderCallbacks.slice(0) : [];
            if (!items.length) return;
            let hasPending = false;
            const provider = storage.provider;
            const prefix = storage.prefix;
            items.forEach((item)=>{
                const icons = item.icons;
                const oldLength = icons.pending.length;
                icons.pending = icons.pending.filter((icon)=>{
                    if (icon.prefix !== prefix) return true;
                    const name = icon.name;
                    if (storage.icons[name]) icons.loaded.push({
                        provider: provider,
                        prefix: prefix,
                        name: name
                    });
                    else if (storage.missing.has(name)) icons.missing.push({
                        provider: provider,
                        prefix: prefix,
                        name: name
                    });
                    else {
                        hasPending = true;
                        return true;
                    }
                    return false;
                });
                if (icons.pending.length !== oldLength) {
                    if (!hasPending) $51b824d77c6dc314$var$removeCallback([
                        storage
                    ], item.id);
                    item.callback(icons.loaded.slice(0), icons.missing.slice(0), icons.pending.slice(0), item.abort);
                }
            });
        });
    }
}
let $51b824d77c6dc314$var$idCounter = 0;
function $51b824d77c6dc314$var$storeCallback(callback, icons, pendingSources) {
    const id = $51b824d77c6dc314$var$idCounter++;
    const abort = $51b824d77c6dc314$var$removeCallback.bind(null, pendingSources, id);
    if (!icons.pending.length) return abort;
    const item = {
        id: id,
        icons: icons,
        callback: callback,
        abort: abort
    };
    pendingSources.forEach((storage)=>{
        (storage.loaderCallbacks || (storage.loaderCallbacks = [])).push(item);
    });
    return abort;
}
const $51b824d77c6dc314$var$storage = /* @__PURE__ */ Object.create(null);
function $51b824d77c6dc314$var$setAPIModule(provider, item) {
    $51b824d77c6dc314$var$storage[provider] = item;
}
function $51b824d77c6dc314$var$getAPIModule(provider) {
    return $51b824d77c6dc314$var$storage[provider] || $51b824d77c6dc314$var$storage[""];
}
function $51b824d77c6dc314$var$listToIcons(list, validate = true, simpleNames = false) {
    const result = [];
    list.forEach((item)=>{
        const icon = typeof item === "string" ? $51b824d77c6dc314$var$stringToIcon(item, validate, simpleNames) : item;
        if (icon) result.push(icon);
    });
    return result;
}
// src/config.ts
var $51b824d77c6dc314$var$defaultConfig = {
    resources: [],
    index: 0,
    timeout: 2e3,
    rotate: 750,
    random: false,
    dataAfterTimeout: false
};
// src/query.ts
function $51b824d77c6dc314$var$sendQuery(config, payload, query, done) {
    const resourcesCount = config.resources.length;
    const startIndex = config.random ? Math.floor(Math.random() * resourcesCount) : config.index;
    let resources;
    if (config.random) {
        let list = config.resources.slice(0);
        resources = [];
        while(list.length > 1){
            const nextIndex = Math.floor(Math.random() * list.length);
            resources.push(list[nextIndex]);
            list = list.slice(0, nextIndex).concat(list.slice(nextIndex + 1));
        }
        resources = resources.concat(list);
    } else resources = config.resources.slice(startIndex).concat(config.resources.slice(0, startIndex));
    const startTime = Date.now();
    let status = "pending";
    let queriesSent = 0;
    let lastError;
    let timer = null;
    let queue = [];
    let doneCallbacks = [];
    if (typeof done === "function") doneCallbacks.push(done);
    function resetTimer() {
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
    }
    function abort() {
        if (status === "pending") status = "aborted";
        resetTimer();
        queue.forEach((item)=>{
            if (item.status === "pending") item.status = "aborted";
        });
        queue = [];
    }
    function subscribe(callback, overwrite) {
        if (overwrite) doneCallbacks = [];
        if (typeof callback === "function") doneCallbacks.push(callback);
    }
    function getQueryStatus() {
        return {
            startTime: startTime,
            payload: payload,
            status: status,
            queriesSent: queriesSent,
            queriesPending: queue.length,
            subscribe: subscribe,
            abort: abort
        };
    }
    function failQuery() {
        status = "failed";
        doneCallbacks.forEach((callback)=>{
            callback(void 0, lastError);
        });
    }
    function clearQueue() {
        queue.forEach((item)=>{
            if (item.status === "pending") item.status = "aborted";
        });
        queue = [];
    }
    function moduleResponse(item, response, data) {
        const isError = response !== "success";
        queue = queue.filter((queued)=>queued !== item);
        switch(status){
            case "pending":
                break;
            case "failed":
                if (isError || !config.dataAfterTimeout) return;
                break;
            default:
                return;
        }
        if (response === "abort") {
            lastError = data;
            failQuery();
            return;
        }
        if (isError) {
            lastError = data;
            if (!queue.length) {
                if (!resources.length) failQuery();
                else execNext();
            }
            return;
        }
        resetTimer();
        clearQueue();
        if (!config.random) {
            const index = config.resources.indexOf(item.resource);
            if (index !== -1 && index !== config.index) config.index = index;
        }
        status = "completed";
        doneCallbacks.forEach((callback)=>{
            callback(data);
        });
    }
    function execNext() {
        if (status !== "pending") return;
        resetTimer();
        const resource = resources.shift();
        if (resource === void 0) {
            if (queue.length) {
                timer = setTimeout(()=>{
                    resetTimer();
                    if (status === "pending") {
                        clearQueue();
                        failQuery();
                    }
                }, config.timeout);
                return;
            }
            failQuery();
            return;
        }
        const item = {
            status: "pending",
            resource: resource,
            callback: (status2, data)=>{
                moduleResponse(item, status2, data);
            }
        };
        queue.push(item);
        queriesSent++;
        timer = setTimeout(execNext, config.rotate);
        query(resource, payload, item.callback);
    }
    setTimeout(execNext);
    return getQueryStatus;
}
// src/index.ts
function $51b824d77c6dc314$var$initRedundancy(cfg) {
    const config = {
        ...$51b824d77c6dc314$var$defaultConfig,
        ...cfg
    };
    let queries = [];
    function cleanup() {
        queries = queries.filter((item)=>item().status === "pending");
    }
    function query(payload, queryCallback, doneCallback) {
        const query2 = $51b824d77c6dc314$var$sendQuery(config, payload, queryCallback, (data, error)=>{
            cleanup();
            if (doneCallback) doneCallback(data, error);
        });
        queries.push(query2);
        return query2;
    }
    function find(callback) {
        return queries.find((value)=>{
            return callback(value);
        }) || null;
    }
    const instance = {
        query: query,
        find: find,
        setIndex: (index)=>{
            config.index = index;
        },
        getIndex: ()=>config.index,
        cleanup: cleanup
    };
    return instance;
}
function $51b824d77c6dc314$var$createAPIConfig(source) {
    let resources;
    if (typeof source.resources === "string") resources = [
        source.resources
    ];
    else {
        resources = source.resources;
        if (!(resources instanceof Array) || !resources.length) return null;
    }
    const result = {
        resources: // API hosts
        resources,
        // Root path
        path: source.path || "/",
        // URL length limit
        maxURL: source.maxURL || 500,
        // Timeout before next host is used.
        rotate: source.rotate || 750,
        // Timeout before failing query.
        timeout: source.timeout || 5e3,
        // Randomise default API end point.
        random: source.random === true,
        // Start index
        index: source.index || 0,
        // Receive data after time out (used if time out kicks in first, then API module sends data anyway).
        dataAfterTimeout: source.dataAfterTimeout !== false
    };
    return result;
}
const $51b824d77c6dc314$var$configStorage = /* @__PURE__ */ Object.create(null);
const $51b824d77c6dc314$var$fallBackAPISources = [
    "https://api.simplesvg.com",
    "https://api.unisvg.com"
];
const $51b824d77c6dc314$var$fallBackAPI = [];
while($51b824d77c6dc314$var$fallBackAPISources.length > 0){
    if ($51b824d77c6dc314$var$fallBackAPISources.length === 1) $51b824d77c6dc314$var$fallBackAPI.push($51b824d77c6dc314$var$fallBackAPISources.shift());
    else if (Math.random() > 0.5) $51b824d77c6dc314$var$fallBackAPI.push($51b824d77c6dc314$var$fallBackAPISources.shift());
    else $51b824d77c6dc314$var$fallBackAPI.push($51b824d77c6dc314$var$fallBackAPISources.pop());
}
$51b824d77c6dc314$var$configStorage[""] = $51b824d77c6dc314$var$createAPIConfig({
    resources: [
        "https://api.iconify.design"
    ].concat($51b824d77c6dc314$var$fallBackAPI)
});
function $51b824d77c6dc314$var$addAPIProvider$1(provider, customConfig) {
    const config = $51b824d77c6dc314$var$createAPIConfig(customConfig);
    if (config === null) return false;
    $51b824d77c6dc314$var$configStorage[provider] = config;
    return true;
}
function $51b824d77c6dc314$var$getAPIConfig(provider) {
    return $51b824d77c6dc314$var$configStorage[provider];
}
function $51b824d77c6dc314$var$listAPIProviders() {
    return Object.keys($51b824d77c6dc314$var$configStorage);
}
function $51b824d77c6dc314$var$emptyCallback$1() {}
const $51b824d77c6dc314$var$redundancyCache = /* @__PURE__ */ Object.create(null);
function $51b824d77c6dc314$var$getRedundancyCache(provider) {
    if (!$51b824d77c6dc314$var$redundancyCache[provider]) {
        const config = $51b824d77c6dc314$var$getAPIConfig(provider);
        if (!config) return;
        const redundancy = $51b824d77c6dc314$var$initRedundancy(config);
        const cachedReundancy = {
            config: config,
            redundancy: redundancy
        };
        $51b824d77c6dc314$var$redundancyCache[provider] = cachedReundancy;
    }
    return $51b824d77c6dc314$var$redundancyCache[provider];
}
function $51b824d77c6dc314$var$sendAPIQuery(target, query, callback) {
    let redundancy;
    let send;
    if (typeof target === "string") {
        const api = $51b824d77c6dc314$var$getAPIModule(target);
        if (!api) {
            callback(void 0, 424);
            return $51b824d77c6dc314$var$emptyCallback$1;
        }
        send = api.send;
        const cached = $51b824d77c6dc314$var$getRedundancyCache(target);
        if (cached) redundancy = cached.redundancy;
    } else {
        const config = $51b824d77c6dc314$var$createAPIConfig(target);
        if (config) {
            redundancy = $51b824d77c6dc314$var$initRedundancy(config);
            const moduleKey = target.resources ? target.resources[0] : "";
            const api = $51b824d77c6dc314$var$getAPIModule(moduleKey);
            if (api) send = api.send;
        }
    }
    if (!redundancy || !send) {
        callback(void 0, 424);
        return $51b824d77c6dc314$var$emptyCallback$1;
    }
    return redundancy.query(query, send, callback)().abort;
}
function $51b824d77c6dc314$var$emptyCallback() {}
function $51b824d77c6dc314$var$loadedNewIcons(storage) {
    if (!storage.iconsLoaderFlag) {
        storage.iconsLoaderFlag = true;
        setTimeout(()=>{
            storage.iconsLoaderFlag = false;
            $51b824d77c6dc314$var$updateCallbacks(storage);
        });
    }
}
function $51b824d77c6dc314$var$checkIconNamesForAPI(icons) {
    const valid = [];
    const invalid = [];
    icons.forEach((name)=>{
        (name.match($51b824d77c6dc314$var$matchIconName) ? valid : invalid).push(name);
    });
    return {
        valid: valid,
        invalid: invalid
    };
}
function $51b824d77c6dc314$var$parseLoaderResponse(storage, icons, data) {
    function checkMissing() {
        const pending = storage.pendingIcons;
        icons.forEach((name)=>{
            if (pending) pending.delete(name);
            if (!storage.icons[name]) storage.missing.add(name);
        });
    }
    if (data && typeof data === "object") try {
        const parsed = $51b824d77c6dc314$var$addIconSet(storage, data);
        if (!parsed.length) {
            checkMissing();
            return;
        }
    } catch (err) {
        console.error(err);
    }
    checkMissing();
    $51b824d77c6dc314$var$loadedNewIcons(storage);
}
function $51b824d77c6dc314$var$parsePossiblyAsyncResponse(response, callback) {
    if (response instanceof Promise) response.then((data)=>{
        callback(data);
    }).catch(()=>{
        callback(null);
    });
    else callback(response);
}
function $51b824d77c6dc314$var$loadNewIcons(storage, icons) {
    if (!storage.iconsToLoad) storage.iconsToLoad = icons;
    else storage.iconsToLoad = storage.iconsToLoad.concat(icons).sort();
    if (!storage.iconsQueueFlag) {
        storage.iconsQueueFlag = true;
        setTimeout(()=>{
            storage.iconsQueueFlag = false;
            const { provider: provider, prefix: prefix } = storage;
            const icons2 = storage.iconsToLoad;
            delete storage.iconsToLoad;
            if (!icons2 || !icons2.length) return;
            const customIconLoader = storage.loadIcon;
            if (storage.loadIcons && (icons2.length > 1 || !customIconLoader)) {
                $51b824d77c6dc314$var$parsePossiblyAsyncResponse(storage.loadIcons(icons2, prefix, provider), (data)=>{
                    $51b824d77c6dc314$var$parseLoaderResponse(storage, icons2, data);
                });
                return;
            }
            if (customIconLoader) {
                icons2.forEach((name)=>{
                    const response = customIconLoader(name, prefix, provider);
                    $51b824d77c6dc314$var$parsePossiblyAsyncResponse(response, (data)=>{
                        const iconSet = data ? {
                            prefix: prefix,
                            icons: {
                                [name]: data
                            }
                        } : null;
                        $51b824d77c6dc314$var$parseLoaderResponse(storage, [
                            name
                        ], iconSet);
                    });
                });
                return;
            }
            const { valid: valid, invalid: invalid } = $51b824d77c6dc314$var$checkIconNamesForAPI(icons2);
            if (invalid.length) $51b824d77c6dc314$var$parseLoaderResponse(storage, invalid, null);
            if (!valid.length) return;
            const api = prefix.match($51b824d77c6dc314$var$matchIconName) ? $51b824d77c6dc314$var$getAPIModule(provider) : null;
            if (!api) {
                $51b824d77c6dc314$var$parseLoaderResponse(storage, valid, null);
                return;
            }
            const params = api.prepare(provider, prefix, valid);
            params.forEach((item)=>{
                $51b824d77c6dc314$var$sendAPIQuery(provider, item, (data)=>{
                    $51b824d77c6dc314$var$parseLoaderResponse(storage, item.icons, data);
                });
            });
        });
    }
}
const $51b824d77c6dc314$var$loadIcons$1 = (icons, callback)=>{
    const cleanedIcons = $51b824d77c6dc314$var$listToIcons(icons, true, $51b824d77c6dc314$var$allowSimpleNames());
    const sortedIcons = $51b824d77c6dc314$var$sortIcons(cleanedIcons);
    if (!sortedIcons.pending.length) {
        let callCallback = true;
        if (callback) setTimeout(()=>{
            if (callCallback) callback(sortedIcons.loaded, sortedIcons.missing, sortedIcons.pending, $51b824d77c6dc314$var$emptyCallback);
        });
        return ()=>{
            callCallback = false;
        };
    }
    const newIcons = /* @__PURE__ */ Object.create(null);
    const sources = [];
    let lastProvider, lastPrefix;
    sortedIcons.pending.forEach((icon)=>{
        const { provider: provider, prefix: prefix } = icon;
        if (prefix === lastPrefix && provider === lastProvider) return;
        lastProvider = provider;
        lastPrefix = prefix;
        sources.push($51b824d77c6dc314$var$getStorage(provider, prefix));
        const providerNewIcons = newIcons[provider] || (newIcons[provider] = /* @__PURE__ */ Object.create(null));
        if (!providerNewIcons[prefix]) providerNewIcons[prefix] = [];
    });
    sortedIcons.pending.forEach((icon)=>{
        const { provider: provider, prefix: prefix, name: name } = icon;
        const storage = $51b824d77c6dc314$var$getStorage(provider, prefix);
        const pendingQueue = storage.pendingIcons || (storage.pendingIcons = /* @__PURE__ */ new Set());
        if (!pendingQueue.has(name)) {
            pendingQueue.add(name);
            newIcons[provider][prefix].push(name);
        }
    });
    sources.forEach((storage)=>{
        const list = newIcons[storage.provider][storage.prefix];
        if (list.length) $51b824d77c6dc314$var$loadNewIcons(storage, list);
    });
    return callback ? $51b824d77c6dc314$var$storeCallback(callback, sortedIcons, sources) : $51b824d77c6dc314$var$emptyCallback;
};
const $51b824d77c6dc314$var$loadIcon$1 = (icon)=>{
    return new Promise((fulfill, reject)=>{
        const iconObj = typeof icon === "string" ? $51b824d77c6dc314$var$stringToIcon(icon, true) : icon;
        if (!iconObj) {
            reject(icon);
            return;
        }
        $51b824d77c6dc314$var$loadIcons$1([
            iconObj || icon
        ], (loaded)=>{
            if (loaded.length && iconObj) {
                const data = $51b824d77c6dc314$var$getIconData(iconObj);
                if (data) {
                    fulfill({
                        ...$51b824d77c6dc314$var$defaultIconProps,
                        ...data
                    });
                    return;
                }
            }
            reject(icon);
        });
    });
};
/**
 * Test icon string
 */ function $51b824d77c6dc314$var$testIconObject(value) {
    try {
        const obj = typeof value === 'string' ? JSON.parse(value) : value;
        if (typeof obj.body === 'string') return {
            ...obj
        };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (err) {
    //
    }
}
/**
 * Parse icon value, load if needed
 */ function $51b824d77c6dc314$var$parseIconValue(value, onload) {
    if (typeof value === 'object') {
        const data = $51b824d77c6dc314$var$testIconObject(value);
        return {
            data: data,
            value: value
        };
    }
    if (typeof value !== 'string') // Invalid value
    return {
        value: value
    };
    // Check for JSON
    if (value.includes('{')) {
        const data = $51b824d77c6dc314$var$testIconObject(value);
        if (data) return {
            data: data,
            value: value
        };
    }
    // Parse icon name
    const name = $51b824d77c6dc314$var$stringToIcon(value, true, true);
    if (!name) return {
        value: value
    };
    // Valid icon name: check if data is available
    const data = $51b824d77c6dc314$var$getIconData(name);
    // Icon data exists or icon has no prefix. Do not load icon from API if icon has no prefix
    if (data !== undefined || !name.prefix) return {
        value: value,
        name: name,
        data: data
    };
    // Load icon
    const loading = $51b824d77c6dc314$var$loadIcons$1([
        name
    ], ()=>onload(value, name, $51b824d77c6dc314$var$getIconData(name)));
    return {
        value: value,
        name: name,
        loading: loading
    };
}
// Check for Safari
let $51b824d77c6dc314$var$isBuggedSafari = false;
try {
    $51b824d77c6dc314$var$isBuggedSafari = navigator.vendor.indexOf('Apple') === 0;
// eslint-disable-next-line @typescript-eslint/no-unused-vars
} catch (err) {
//
}
/**
 * Get render mode
 */ function $51b824d77c6dc314$var$getRenderMode(body, mode) {
    switch(mode){
        // Force mode
        case 'svg':
        case 'bg':
        case 'mask':
            return mode;
    }
    // Check for animation, use 'style' for animated icons, unless browser is Safari
    // (only <a>, which should be ignored or animations start with '<a')
    if (mode !== 'style' && ($51b824d77c6dc314$var$isBuggedSafari || body.indexOf('<a') === -1)) // Render <svg>
    return 'svg';
    // Use background or mask
    return body.indexOf('currentColor') === -1 ? 'bg' : 'mask';
}
const $51b824d77c6dc314$var$unitsSplit = /(-?[0-9.]*[0-9]+[0-9.]*)/g;
const $51b824d77c6dc314$var$unitsTest = /^-?[0-9.]*[0-9]+[0-9.]*$/g;
function $51b824d77c6dc314$var$calculateSize$1(size, ratio, precision) {
    if (ratio === 1) return size;
    precision = precision || 100;
    if (typeof size === "number") return Math.ceil(size * ratio * precision) / precision;
    if (typeof size !== "string") return size;
    const oldParts = size.split($51b824d77c6dc314$var$unitsSplit);
    if (oldParts === null || !oldParts.length) return size;
    const newParts = [];
    let code = oldParts.shift();
    let isNumber = $51b824d77c6dc314$var$unitsTest.test(code);
    while(true){
        if (isNumber) {
            const num = parseFloat(code);
            if (isNaN(num)) newParts.push(code);
            else newParts.push(Math.ceil(num * ratio * precision) / precision);
        } else newParts.push(code);
        code = oldParts.shift();
        if (code === void 0) return newParts.join("");
        isNumber = !isNumber;
    }
}
function $51b824d77c6dc314$var$splitSVGDefs(content, tag = "defs") {
    let defs = "";
    const index = content.indexOf("<" + tag);
    while(index >= 0){
        const start = content.indexOf(">", index);
        const end = content.indexOf("</" + tag);
        if (start === -1 || end === -1) break;
        const endEnd = content.indexOf(">", end);
        if (endEnd === -1) break;
        defs += content.slice(start + 1, end).trim();
        content = content.slice(0, index).trim() + content.slice(endEnd + 1);
    }
    return {
        defs: defs,
        content: content
    };
}
function $51b824d77c6dc314$var$mergeDefsAndContent(defs, content) {
    return defs ? "<defs>" + defs + "</defs>" + content : content;
}
function $51b824d77c6dc314$var$wrapSVGContent(body, start, end) {
    const split = $51b824d77c6dc314$var$splitSVGDefs(body);
    return $51b824d77c6dc314$var$mergeDefsAndContent(split.defs, start + split.content + end);
}
const $51b824d77c6dc314$var$isUnsetKeyword = (value)=>value === "unset" || value === "undefined" || value === "none";
function $51b824d77c6dc314$var$iconToSVG(icon, customisations) {
    const fullIcon = {
        ...$51b824d77c6dc314$var$defaultIconProps,
        ...icon
    };
    const fullCustomisations = {
        ...$51b824d77c6dc314$var$defaultIconCustomisations,
        ...customisations
    };
    const box = {
        left: fullIcon.left,
        top: fullIcon.top,
        width: fullIcon.width,
        height: fullIcon.height
    };
    let body = fullIcon.body;
    [
        fullIcon,
        fullCustomisations
    ].forEach((props)=>{
        const transformations = [];
        const hFlip = props.hFlip;
        const vFlip = props.vFlip;
        let rotation = props.rotate;
        if (hFlip) {
            if (vFlip) rotation += 2;
            else {
                transformations.push("translate(" + (box.width + box.left).toString() + " " + (0 - box.top).toString() + ")");
                transformations.push("scale(-1 1)");
                box.top = box.left = 0;
            }
        } else if (vFlip) {
            transformations.push("translate(" + (0 - box.left).toString() + " " + (box.height + box.top).toString() + ")");
            transformations.push("scale(1 -1)");
            box.top = box.left = 0;
        }
        let tempValue;
        if (rotation < 0) rotation -= Math.floor(rotation / 4) * 4;
        rotation = rotation % 4;
        switch(rotation){
            case 1:
                tempValue = box.height / 2 + box.top;
                transformations.unshift("rotate(90 " + tempValue.toString() + " " + tempValue.toString() + ")");
                break;
            case 2:
                transformations.unshift("rotate(180 " + (box.width / 2 + box.left).toString() + " " + (box.height / 2 + box.top).toString() + ")");
                break;
            case 3:
                tempValue = box.width / 2 + box.left;
                transformations.unshift("rotate(-90 " + tempValue.toString() + " " + tempValue.toString() + ")");
                break;
        }
        if (rotation % 2 === 1) {
            if (box.left !== box.top) {
                tempValue = box.left;
                box.left = box.top;
                box.top = tempValue;
            }
            if (box.width !== box.height) {
                tempValue = box.width;
                box.width = box.height;
                box.height = tempValue;
            }
        }
        if (transformations.length) body = $51b824d77c6dc314$var$wrapSVGContent(body, '<g transform="' + transformations.join(" ") + '">', "</g>");
    });
    const customisationsWidth = fullCustomisations.width;
    const customisationsHeight = fullCustomisations.height;
    const boxWidth = box.width;
    const boxHeight = box.height;
    let width;
    let height;
    if (customisationsWidth === null) {
        height = customisationsHeight === null ? "1em" : customisationsHeight === "auto" ? boxHeight : customisationsHeight;
        width = $51b824d77c6dc314$var$calculateSize$1(height, boxWidth / boxHeight);
    } else {
        width = customisationsWidth === "auto" ? boxWidth : customisationsWidth;
        height = customisationsHeight === null ? $51b824d77c6dc314$var$calculateSize$1(width, boxHeight / boxWidth) : customisationsHeight === "auto" ? boxHeight : customisationsHeight;
    }
    const attributes = {};
    const setAttr = (prop, value)=>{
        if (!$51b824d77c6dc314$var$isUnsetKeyword(value)) attributes[prop] = value.toString();
    };
    setAttr("width", width);
    setAttr("height", height);
    const viewBox = [
        box.left,
        box.top,
        boxWidth,
        boxHeight
    ];
    attributes.viewBox = viewBox.join(" ");
    return {
        attributes: attributes,
        viewBox: viewBox,
        body: body
    };
}
function $51b824d77c6dc314$var$iconToHTML$1(body, attributes) {
    let renderAttribsHTML = body.indexOf("xlink:") === -1 ? "" : ' xmlns:xlink="http://www.w3.org/1999/xlink"';
    for(const attr in attributes)renderAttribsHTML += " " + attr + '="' + attributes[attr] + '"';
    return '<svg xmlns="http://www.w3.org/2000/svg"' + renderAttribsHTML + ">" + body + "</svg>";
}
function $51b824d77c6dc314$var$encodeSVGforURL(svg) {
    return svg.replace(/"/g, "'").replace(/%/g, "%25").replace(/#/g, "%23").replace(/</g, "%3C").replace(/>/g, "%3E").replace(/\s+/g, " ");
}
function $51b824d77c6dc314$var$svgToData(svg) {
    return "data:image/svg+xml," + $51b824d77c6dc314$var$encodeSVGforURL(svg);
}
function $51b824d77c6dc314$var$svgToURL$1(svg) {
    return 'url("' + $51b824d77c6dc314$var$svgToData(svg) + '")';
}
const $51b824d77c6dc314$var$detectFetch = ()=>{
    let callback;
    try {
        callback = fetch;
        if (typeof callback === "function") return callback;
    } catch (err) {}
};
let $51b824d77c6dc314$var$fetchModule = $51b824d77c6dc314$var$detectFetch();
function $51b824d77c6dc314$var$setFetch(fetch2) {
    $51b824d77c6dc314$var$fetchModule = fetch2;
}
function $51b824d77c6dc314$var$getFetch() {
    return $51b824d77c6dc314$var$fetchModule;
}
function $51b824d77c6dc314$var$calculateMaxLength(provider, prefix) {
    const config = $51b824d77c6dc314$var$getAPIConfig(provider);
    if (!config) return 0;
    let result;
    if (!config.maxURL) result = 0;
    else {
        let maxHostLength = 0;
        config.resources.forEach((item)=>{
            const host = item;
            maxHostLength = Math.max(maxHostLength, host.length);
        });
        const url = prefix + ".json?icons=";
        result = config.maxURL - maxHostLength - config.path.length - url.length;
    }
    return result;
}
function $51b824d77c6dc314$var$shouldAbort(status) {
    return status === 404;
}
const $51b824d77c6dc314$var$prepare = (provider, prefix, icons)=>{
    const results = [];
    const maxLength = $51b824d77c6dc314$var$calculateMaxLength(provider, prefix);
    const type = "icons";
    let item = {
        type: type,
        provider: provider,
        prefix: prefix,
        icons: []
    };
    let length = 0;
    icons.forEach((name, index)=>{
        length += name.length + 1;
        if (length >= maxLength && index > 0) {
            results.push(item);
            item = {
                type: type,
                provider: provider,
                prefix: prefix,
                icons: []
            };
            length = name.length;
        }
        item.icons.push(name);
    });
    results.push(item);
    return results;
};
function $51b824d77c6dc314$var$getPath(provider) {
    if (typeof provider === "string") {
        const config = $51b824d77c6dc314$var$getAPIConfig(provider);
        if (config) return config.path;
    }
    return "/";
}
const $51b824d77c6dc314$var$send = (host, params, callback)=>{
    if (!$51b824d77c6dc314$var$fetchModule) {
        callback("abort", 424);
        return;
    }
    let path = $51b824d77c6dc314$var$getPath(params.provider);
    switch(params.type){
        case "icons":
            {
                const prefix = params.prefix;
                const icons = params.icons;
                const iconsList = icons.join(",");
                const urlParams = new URLSearchParams({
                    icons: iconsList
                });
                path += prefix + ".json?" + urlParams.toString();
                break;
            }
        case "custom":
            {
                const uri = params.uri;
                path += uri.slice(0, 1) === "/" ? uri.slice(1) : uri;
                break;
            }
        default:
            callback("abort", 400);
            return;
    }
    let defaultError = 503;
    $51b824d77c6dc314$var$fetchModule(host + path).then((response)=>{
        const status = response.status;
        if (status !== 200) {
            setTimeout(()=>{
                callback($51b824d77c6dc314$var$shouldAbort(status) ? "abort" : "next", status);
            });
            return;
        }
        defaultError = 501;
        return response.json();
    }).then((data)=>{
        if (typeof data !== "object" || data === null) {
            setTimeout(()=>{
                if (data === 404) callback("abort", data);
                else callback("next", defaultError);
            });
            return;
        }
        setTimeout(()=>{
            callback("success", data);
        });
    }).catch(()=>{
        callback("next", defaultError);
    });
};
const $51b824d77c6dc314$var$fetchAPIModule = {
    prepare: $51b824d77c6dc314$var$prepare,
    send: $51b824d77c6dc314$var$send
};
function $51b824d77c6dc314$var$setCustomIconsLoader$1(loader, prefix, provider) {
    $51b824d77c6dc314$var$getStorage(provider || "", prefix).loadIcons = loader;
}
function $51b824d77c6dc314$var$setCustomIconLoader$1(loader, prefix, provider) {
    $51b824d77c6dc314$var$getStorage(provider || "", prefix).loadIcon = loader;
}
/**
 * Attribute to add
 */ const $51b824d77c6dc314$var$nodeAttr = 'data-style';
/**
 * Custom style to add to each node
 */ let $51b824d77c6dc314$var$customStyle = '';
/**
 * Set custom style to add to all components
 *
 * Affects only components rendered after function call
 */ function $51b824d77c6dc314$export$77258b5efdb5130e(style) {
    $51b824d77c6dc314$var$customStyle = style;
}
/**
 * Add/update style node
 */ function $51b824d77c6dc314$var$updateStyle(parent, inline) {
    // Get node, create if needed
    let styleNode = Array.from(parent.childNodes).find((node)=>node.hasAttribute && node.hasAttribute($51b824d77c6dc314$var$nodeAttr));
    if (!styleNode) {
        styleNode = document.createElement('style');
        styleNode.setAttribute($51b824d77c6dc314$var$nodeAttr, $51b824d77c6dc314$var$nodeAttr);
        parent.appendChild(styleNode);
    }
    // Update content
    styleNode.textContent = ':host{display:inline-block;vertical-align:' + (inline ? '-0.125em' : '0') + '}span,svg{display:block;margin:auto}' + $51b824d77c6dc314$var$customStyle;
}
// Core
/**
 * Get functions and initialise stuff
 */ function $51b824d77c6dc314$var$exportFunctions() {
    /**
     * Initialise stuff
     */ // Set API module
    $51b824d77c6dc314$var$setAPIModule('', $51b824d77c6dc314$var$fetchAPIModule);
    // Allow simple icon names
    $51b824d77c6dc314$var$allowSimpleNames(true);
    let _window;
    try {
        _window = window;
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (err) {
    //
    }
    if (_window) {
        // Load icons from global "IconifyPreload"
        if (_window.IconifyPreload !== void 0) {
            const preload = _window.IconifyPreload;
            const err = 'Invalid IconifyPreload syntax.';
            if (typeof preload === 'object' && preload !== null) (preload instanceof Array ? preload : [
                preload
            ]).forEach((item)=>{
                try {
                    if (// Check if item is an object and not null/array
                    typeof item !== 'object' || item === null || item instanceof Array || // Check for 'icons' and 'prefix'
                    typeof item.icons !== 'object' || typeof item.prefix !== 'string' || // Add icon set
                    !$51b824d77c6dc314$var$addCollection$1(item)) console.error(err);
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                } catch (e) {
                    console.error(err);
                }
            });
        }
        // Set API from global "IconifyProviders"
        if (_window.IconifyProviders !== void 0) {
            const providers = _window.IconifyProviders;
            if (typeof providers === 'object' && providers !== null) for(const key in providers){
                const err = 'IconifyProviders[' + key + '] is invalid.';
                try {
                    const value = providers[key];
                    if (typeof value !== 'object' || !value || value.resources === void 0) continue;
                    if (!$51b824d77c6dc314$var$addAPIProvider$1(key, value)) console.error(err);
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                } catch (e) {
                    console.error(err);
                }
            }
        }
    }
    const _api = {
        getAPIConfig: $51b824d77c6dc314$var$getAPIConfig,
        setAPIModule: $51b824d77c6dc314$var$setAPIModule,
        sendAPIQuery: $51b824d77c6dc314$var$sendAPIQuery,
        setFetch: $51b824d77c6dc314$var$setFetch,
        getFetch: $51b824d77c6dc314$var$getFetch,
        listAPIProviders: $51b824d77c6dc314$var$listAPIProviders
    };
    return {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        enableCache: (storage)=>{
        // No longer used
        },
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        disableCache: (storage)=>{
        // No longer used
        },
        iconLoaded: $51b824d77c6dc314$var$iconLoaded$1,
        iconExists: $51b824d77c6dc314$var$iconLoaded$1,
        getIcon: $51b824d77c6dc314$var$getIcon$1,
        listIcons: $51b824d77c6dc314$var$listIcons$1,
        addIcon: $51b824d77c6dc314$var$addIcon$1,
        addCollection: $51b824d77c6dc314$var$addCollection$1,
        calculateSize: $51b824d77c6dc314$var$calculateSize$1,
        buildIcon: $51b824d77c6dc314$var$iconToSVG,
        iconToHTML: $51b824d77c6dc314$var$iconToHTML$1,
        svgToURL: $51b824d77c6dc314$var$svgToURL$1,
        loadIcons: $51b824d77c6dc314$var$loadIcons$1,
        loadIcon: $51b824d77c6dc314$var$loadIcon$1,
        addAPIProvider: $51b824d77c6dc314$var$addAPIProvider$1,
        setCustomIconLoader: $51b824d77c6dc314$var$setCustomIconLoader$1,
        setCustomIconsLoader: $51b824d77c6dc314$var$setCustomIconsLoader$1,
        appendCustomStyle: $51b824d77c6dc314$export$77258b5efdb5130e,
        _api: _api
    };
}
// List of properties to apply
const $51b824d77c6dc314$var$monotoneProps = {
    'background-color': 'currentColor'
};
const $51b824d77c6dc314$var$coloredProps = {
    'background-color': 'transparent'
};
// Dynamically add common props to variables above
const $51b824d77c6dc314$var$propsToAdd = {
    image: 'var(--svg)',
    repeat: 'no-repeat',
    size: '100% 100%'
};
const $51b824d77c6dc314$var$propsToAddTo = {
    '-webkit-mask': $51b824d77c6dc314$var$monotoneProps,
    'mask': $51b824d77c6dc314$var$monotoneProps,
    'background': $51b824d77c6dc314$var$coloredProps
};
for(const prefix in $51b824d77c6dc314$var$propsToAddTo){
    const list = $51b824d77c6dc314$var$propsToAddTo[prefix];
    for(const prop in $51b824d77c6dc314$var$propsToAdd)list[prefix + '-' + prop] = $51b824d77c6dc314$var$propsToAdd[prop];
}
/**
 * Fix size: add 'px' to numbers
 */ function $51b824d77c6dc314$var$fixSize(value) {
    return value ? value + (value.match(/^[-0-9.]+$/) ? 'px' : '') : 'inherit';
}
/**
 * Render node as <span>
 */ function $51b824d77c6dc314$var$renderSPAN(data, icon, useMask) {
    const node = document.createElement('span');
    // Body
    let body = data.body;
    if (body.indexOf('<a') !== -1) // Animated SVG: add something to fix timing bug
    body += '<!-- ' + Date.now() + ' -->';
    // Generate SVG as URL
    const renderAttribs = data.attributes;
    const html = $51b824d77c6dc314$var$iconToHTML$1(body, {
        ...renderAttribs,
        width: icon.width + '',
        height: icon.height + ''
    });
    const url = $51b824d77c6dc314$var$svgToURL$1(html);
    // Generate style
    const svgStyle = node.style;
    const styles = {
        '--svg': url,
        'width': $51b824d77c6dc314$var$fixSize(renderAttribs.width),
        'height': $51b824d77c6dc314$var$fixSize(renderAttribs.height),
        ...useMask ? $51b824d77c6dc314$var$monotoneProps : $51b824d77c6dc314$var$coloredProps
    };
    // Apply style
    for(const prop in styles)svgStyle.setProperty(prop, styles[prop]);
    return node;
}
let $51b824d77c6dc314$var$policy;
function $51b824d77c6dc314$var$createPolicy() {
    try {
        $51b824d77c6dc314$var$policy = window.trustedTypes.createPolicy("iconify", {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-return
            createHTML: (s)=>s
        });
    } catch (err) {
        $51b824d77c6dc314$var$policy = null;
    }
}
function $51b824d77c6dc314$var$cleanUpInnerHTML(html) {
    if ($51b824d77c6dc314$var$policy === void 0) $51b824d77c6dc314$var$createPolicy();
    return $51b824d77c6dc314$var$policy ? $51b824d77c6dc314$var$policy.createHTML(html) : html;
}
/**
 * Render node as <svg>
 */ function $51b824d77c6dc314$var$renderSVG(data) {
    const node = document.createElement('span');
    // Add style if needed
    const attr = data.attributes;
    let style = '';
    if (!attr.width) style = 'width: inherit;';
    if (!attr.height) style += 'height: inherit;';
    if (style) attr.style = style;
    // Generate SVG
    const html = $51b824d77c6dc314$var$iconToHTML$1(data.body, attr);
    node.innerHTML = $51b824d77c6dc314$var$cleanUpInnerHTML(html);
    return node.firstChild;
}
/**
 * Find icon node
 */ function $51b824d77c6dc314$var$findIconElement(parent) {
    return Array.from(parent.childNodes).find((node)=>{
        const tag = node.tagName && node.tagName.toUpperCase();
        return tag === 'SPAN' || tag === 'SVG';
    });
}
/**
 * Render icon
 */ function $51b824d77c6dc314$var$renderIcon(parent, state) {
    const iconData = state.icon.data;
    const customisations = state.customisations;
    // Render icon
    const renderData = $51b824d77c6dc314$var$iconToSVG(iconData, customisations);
    if (customisations.preserveAspectRatio) renderData.attributes['preserveAspectRatio'] = customisations.preserveAspectRatio;
    const mode = state.renderedMode;
    let node;
    switch(mode){
        case 'svg':
            node = $51b824d77c6dc314$var$renderSVG(renderData);
            break;
        default:
            node = $51b824d77c6dc314$var$renderSPAN(renderData, {
                ...$51b824d77c6dc314$var$defaultIconProps,
                ...iconData
            }, mode === 'mask');
    }
    // Set element
    const oldNode = $51b824d77c6dc314$var$findIconElement(parent);
    if (oldNode) {
        // Replace old element
        if (node.tagName === 'SPAN' && oldNode.tagName === node.tagName) // Swap style instead of whole node
        oldNode.setAttribute('style', node.getAttribute('style'));
        else parent.replaceChild(node, oldNode);
    } else // Add new element
    parent.appendChild(node);
}
/**
 * Set state to PendingState
 */ function $51b824d77c6dc314$var$setPendingState(icon, inline, lastState) {
    const lastRender = lastState && (lastState.rendered ? lastState : lastState.lastRender);
    return {
        rendered: false,
        inline: inline,
        icon: icon,
        lastRender: lastRender
    };
}
/**
 * Register 'iconify-icon' component, if it does not exist
 */ function $51b824d77c6dc314$var$defineIconifyIcon(name = 'iconify-icon') {
    // Check for custom elements registry and HTMLElement
    let customElements;
    let ParentClass;
    try {
        customElements = window.customElements;
        ParentClass = window.HTMLElement;
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (err) {
        return;
    }
    // Make sure registry and HTMLElement exist
    if (!customElements || !ParentClass) return;
    // Check for duplicate
    const ConflictingClass = customElements.get(name);
    if (ConflictingClass) return ConflictingClass;
    // All attributes
    const attributes = [
        // Icon
        'icon',
        // Mode
        'mode',
        'inline',
        'noobserver',
        // Customisations
        'width',
        'height',
        'rotate',
        'flip'
    ];
    /**
     * Component class
     */ const IconifyIcon = class extends ParentClass {
        // Root
        _shadowRoot;
        // Initialised
        _initialised = false;
        // Icon state
        _state;
        // Attributes check queued
        _checkQueued = false;
        // Connected
        _connected = false;
        // Observer
        _observer = null;
        _visible = true;
        /**
         * Constructor
         */ constructor(){
            super();
            // Attach shadow DOM
            const root = this._shadowRoot = this.attachShadow({
                mode: 'open'
            });
            // Add style
            const inline = this.hasAttribute('inline');
            $51b824d77c6dc314$var$updateStyle(root, inline);
            // Create empty state
            this._state = $51b824d77c6dc314$var$setPendingState({
                value: ''
            }, inline);
            // Queue icon render
            this._queueCheck();
        }
        /**
         * Connected to DOM
         */ connectedCallback() {
            this._connected = true;
            this.startObserver();
        }
        /**
         * Disconnected from DOM
         */ disconnectedCallback() {
            this._connected = false;
            this.stopObserver();
        }
        /**
         * Observed attributes
         */ static get observedAttributes() {
            return attributes.slice(0);
        }
        /**
         * Observed properties that are different from attributes
         *
         * Experimental! Need to test with various frameworks that support it
         */ /*
        static get properties() {
            return {
                inline: {
                    type: Boolean,
                    reflect: true,
                },
                // Not listing other attributes because they are strings or combination
                // of string and another type. Cannot have multiple types
            };
        }
        */ /**
         * Attribute has changed
         */ attributeChangedCallback(name) {
            switch(name){
                case 'inline':
                    {
                        // Update immediately: not affected by other attributes
                        const newInline = this.hasAttribute('inline');
                        const state = this._state;
                        if (newInline !== state.inline) {
                            // Update style if inline mode changed
                            state.inline = newInline;
                            $51b824d77c6dc314$var$updateStyle(this._shadowRoot, newInline);
                        }
                        break;
                    }
                case 'noobserver':
                    {
                        const value = this.hasAttribute('noobserver');
                        if (value) this.startObserver();
                        else this.stopObserver();
                        break;
                    }
                default:
                    // Queue check for other attributes
                    this._queueCheck();
            }
        }
        /**
         * Get/set icon
         */ get icon() {
            const value = this.getAttribute('icon');
            if (value && value.slice(0, 1) === '{') try {
                return JSON.parse(value);
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            } catch (err) {
            //
            }
            return value;
        }
        set icon(value) {
            if (typeof value === 'object') value = JSON.stringify(value);
            this.setAttribute('icon', value);
        }
        /**
         * Get/set inline
         */ get inline() {
            return this.hasAttribute('inline');
        }
        set inline(value) {
            if (value) this.setAttribute('inline', 'true');
            else this.removeAttribute('inline');
        }
        /**
         * Get/set observer
         */ get observer() {
            return this.hasAttribute('observer');
        }
        set observer(value) {
            if (value) this.setAttribute('observer', 'true');
            else this.removeAttribute('observer');
        }
        /**
         * Restart animation
         */ restartAnimation() {
            const state = this._state;
            if (state.rendered) {
                const root = this._shadowRoot;
                if (state.renderedMode === 'svg') // Update root node
                try {
                    root.lastChild.setCurrentTime(0);
                    return;
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                } catch (err) {
                // Failed: setCurrentTime() is not supported
                }
                $51b824d77c6dc314$var$renderIcon(root, state);
            }
        }
        /**
         * Get status
         */ get status() {
            const state = this._state;
            return state.rendered ? 'rendered' : state.icon.data === null ? 'failed' : 'loading';
        }
        /**
         * Queue attributes re-check
         */ _queueCheck() {
            if (!this._checkQueued) {
                this._checkQueued = true;
                setTimeout(()=>{
                    this._check();
                });
            }
        }
        /**
         * Check for changes
         */ _check() {
            if (!this._checkQueued) return;
            this._checkQueued = false;
            const state = this._state;
            // Get icon
            const newIcon = this.getAttribute('icon');
            if (newIcon !== state.icon.value) {
                this._iconChanged(newIcon);
                return;
            }
            // Ignore other attributes if icon is not rendered
            if (!state.rendered || !this._visible) return;
            // Check for mode and attribute changes
            const mode = this.getAttribute('mode');
            const customisations = $51b824d77c6dc314$var$getCustomisations(this);
            if (state.attrMode !== mode || $51b824d77c6dc314$var$haveCustomisationsChanged(state.customisations, customisations) || !$51b824d77c6dc314$var$findIconElement(this._shadowRoot)) this._renderIcon(state.icon, customisations, mode);
        }
        /**
         * Icon value has changed
         */ _iconChanged(newValue) {
            const icon = $51b824d77c6dc314$var$parseIconValue(newValue, (value, name, data)=>{
                // Asynchronous callback: re-check values to make sure stuff wasn't changed
                const state = this._state;
                if (state.rendered || this.getAttribute('icon') !== value) // Icon data is already available or icon attribute was changed
                return;
                // Change icon
                const icon = {
                    value: value,
                    name: name,
                    data: data
                };
                if (icon.data) // Render icon
                this._gotIconData(icon);
                else // Nothing to render: update icon in state
                state.icon = icon;
            });
            if (icon.data) // Icon is ready to render
            this._gotIconData(icon);
            else // Pending icon
            this._state = $51b824d77c6dc314$var$setPendingState(icon, this._state.inline, this._state);
        }
        /**
         * Force render icon on state change
         */ _forceRender() {
            if (!this._visible) {
                // Remove icon
                const node = $51b824d77c6dc314$var$findIconElement(this._shadowRoot);
                if (node) this._shadowRoot.removeChild(node);
                return;
            }
            // Re-render icon
            this._queueCheck();
        }
        /**
         * Got new icon data, icon is ready to (re)render
         */ _gotIconData(icon) {
            this._checkQueued = false;
            this._renderIcon(icon, $51b824d77c6dc314$var$getCustomisations(this), this.getAttribute('mode'));
        }
        /**
         * Re-render based on icon data
         */ _renderIcon(icon, customisations, attrMode) {
            // Get mode
            const renderedMode = $51b824d77c6dc314$var$getRenderMode(icon.data.body, attrMode);
            // Inline was not changed
            const inline = this._state.inline;
            // Set state and render
            $51b824d77c6dc314$var$renderIcon(this._shadowRoot, this._state = {
                rendered: true,
                icon: icon,
                inline: inline,
                customisations: customisations,
                attrMode: attrMode,
                renderedMode: renderedMode
            });
        }
        /**
         * Start observer
         */ startObserver() {
            if (!this._observer && !this.hasAttribute('noobserver')) try {
                this._observer = new IntersectionObserver((entries)=>{
                    const intersecting = entries.some((entry)=>entry.isIntersecting);
                    if (intersecting !== this._visible) {
                        this._visible = intersecting;
                        this._forceRender();
                    }
                });
                this._observer.observe(this);
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            } catch (err) {
                // Something went wrong, possibly observer is not supported
                if (this._observer) {
                    try {
                        this._observer.disconnect();
                    // eslint-disable-next-line @typescript-eslint/no-unused-vars
                    } catch (err) {
                    //
                    }
                    this._observer = null;
                }
            }
        }
        /**
         * Stop observer
         */ stopObserver() {
            if (this._observer) {
                this._observer.disconnect();
                this._observer = null;
                this._visible = true;
                if (this._connected) // Render icon
                this._forceRender();
            }
        }
    };
    // Add getters and setters
    attributes.forEach((attr)=>{
        if (!(attr in IconifyIcon.prototype)) Object.defineProperty(IconifyIcon.prototype, attr, {
            get: function() {
                return this.getAttribute(attr);
            },
            set: function(value) {
                if (value !== null) this.setAttribute(attr, value);
                else this.removeAttribute(attr);
            }
        });
    });
    // Add exported functions: both as static and instance methods
    const functions = $51b824d77c6dc314$var$exportFunctions();
    for(const key in functions)IconifyIcon[key] = IconifyIcon.prototype[key] = functions[key];
    // Define new component
    customElements.define(name, IconifyIcon);
    return IconifyIcon;
}
/**
 * Create exported data: either component instance or functions
 */ const $51b824d77c6dc314$export$f2c95696e1f78175 = $51b824d77c6dc314$var$defineIconifyIcon() || $51b824d77c6dc314$var$exportFunctions();
/**
 * Export functions
 */ const { enableCache: $51b824d77c6dc314$export$86165a58bbc2b5ab, disableCache: $51b824d77c6dc314$export$36cc41bb19333364, iconLoaded: $51b824d77c6dc314$export$6728fff2d370396a, iconExists: $51b824d77c6dc314$export$26bbc7c9bc8e9ac3, getIcon: $51b824d77c6dc314$export$16b26cd5e98d9100, listIcons: $51b824d77c6dc314$export$a598a3910899291f, addIcon: $51b824d77c6dc314$export$3488242433cbedb, addCollection: $51b824d77c6dc314$export$933f273b2a11730f, calculateSize: $51b824d77c6dc314$export$907c7b8171f13ef1, buildIcon: $51b824d77c6dc314$export$78c1051fc6863a0b, iconToHTML: $51b824d77c6dc314$export$35b4e725dfd7120a, svgToURL: $51b824d77c6dc314$export$5f2addf4eac8b0bb, loadIcons: $51b824d77c6dc314$export$2527eb85cb3fa9f, loadIcon: $51b824d77c6dc314$export$8e757e0542ac47f6, setCustomIconLoader: $51b824d77c6dc314$export$605d11454a711a89, setCustomIconsLoader: $51b824d77c6dc314$export$e4c6e88f1f5eeacc, addAPIProvider: $51b824d77c6dc314$export$ddfda4eca64d59f6, _api: $51b824d77c6dc314$export$14dadc205e26d636 } = $51b824d77c6dc314$export$f2c95696e1f78175;


// Copyright 2021 The Casdoor Authors. All Rights Reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// Copyright 2021 The Casdoor Authors. All Rights Reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
var $37d42502796493b4$exports = {};
"use strict";
var $37d42502796493b4$var$__assign = $37d42502796493b4$exports && $37d42502796493b4$exports.__assign || function() {
    $37d42502796493b4$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $37d42502796493b4$var$__assign.apply(this, arguments);
};
var $37d42502796493b4$var$__importDefault = $37d42502796493b4$exports && $37d42502796493b4$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($37d42502796493b4$exports, "__esModule", {
    value: true
});

var $37d42502796493b4$var$sha256_1 = $37d42502796493b4$var$__importDefault((parcelRequire("dCBbD")));

var $37d42502796493b4$var$enc_base64_1 = $37d42502796493b4$var$__importDefault((parcelRequire("33Dov")));

var $37d42502796493b4$var$lib_typedarrays_1 = $37d42502796493b4$var$__importDefault((parcelRequire("dOqqi")));
var $37d42502796493b4$var$PKCE = /** @class */ function() {
    /**
     * Initialize the instance with configuration
     * @param {IConfig} config
     */ function PKCE(config) {
        this.state = '';
        this.codeVerifier = '';
        this.corsRequestOptions = {};
        this.config = config;
    }
    /**
     * Allow the user to enable cross domain cors requests
     * @param  enable turn the cross domain request options on.
     * @return ICorsOptions
     */ PKCE.prototype.enableCorsCredentials = function(enable) {
        this.corsRequestOptions = enable ? {
            credentials: 'include',
            mode: 'cors'
        } : {};
        return this.corsRequestOptions;
    };
    /**
     * Generate the authorize url
     * @param  {object} additionalParams include additional parameters in the query
     * @return Promise<string>
     */ PKCE.prototype.authorizeUrl = function(additionalParams) {
        if (additionalParams === void 0) additionalParams = {};
        var codeChallenge = this.pkceChallengeFromVerifier();
        var queryString = new URLSearchParams(Object.assign({
            response_type: 'code',
            client_id: this.config.client_id,
            state: this.getState(additionalParams.state || null),
            scope: this.config.requested_scopes,
            redirect_uri: this.config.redirect_uri,
            code_challenge: codeChallenge,
            code_challenge_method: 'S256'
        }, additionalParams)).toString();
        return "".concat(this.config.authorization_endpoint, "?").concat(queryString);
    };
    /**
     * Given the return url, get a token from the oauth server
     * @param  url current urlwith params from server
     * @param  {object} additionalParams include additional parameters in the request body
     * @return {Promise<ITokenResponse>}
     */ PKCE.prototype.exchangeForAccessToken = function(url, additionalParams) {
        var _this = this;
        if (additionalParams === void 0) additionalParams = {};
        return this.parseAuthResponseUrl(url).then(function(q) {
            return fetch(_this.config.token_endpoint, $37d42502796493b4$var$__assign({
                method: 'POST',
                body: new URLSearchParams(Object.assign({
                    grant_type: 'authorization_code',
                    code: q.code,
                    client_id: _this.config.client_id,
                    redirect_uri: _this.config.redirect_uri,
                    code_verifier: _this.getCodeVerifier()
                }, additionalParams)),
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
                }
            }, _this.corsRequestOptions)).then(function(response) {
                return response.json();
            });
        });
    };
    /**
     * Given a refresh token, return a new token from the oauth server
     * @param  refreshTokens current refresh token from server
     * @return {Promise<ITokenResponse>}
     */ PKCE.prototype.refreshAccessToken = function(refreshToken) {
        return fetch(this.config.token_endpoint, {
            method: 'POST',
            body: new URLSearchParams({
                grant_type: 'refresh_token',
                client_id: this.config.client_id,
                refresh_token: refreshToken
            }),
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            }
        }).then(function(response) {
            return response.json();
        });
    };
    PKCE.prototype.revokeToken = function(tokenToExpire, hint) {
        if (hint === void 0) hint = '';
        this.checkEndpoint('revoke_endpoint');
        var params = new URLSearchParams({
            token: tokenToExpire,
            client_id: this.config.client_id
        });
        if (hint.length) params.append('token_type_hint', hint);
        return fetch(this.config.revoke_endpoint, {
            method: 'POST',
            body: params,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            }
        }).then(function(response) {
            return response.ok;
        }).catch(function() {
            return false;
        });
    };
    PKCE.prototype.checkEndpoint = function(propertyName) {
        if (!this.config.hasOwnProperty(propertyName)) throw new Error("".concat(propertyName, " not configured."));
        var url = new URL(this.config[propertyName]);
        var isLocalHost = [
            'localhost',
            '127.0.0.1'
        ].indexOf(url.hostname) !== -1;
        if (url.protocol !== 'https:' && !isLocalHost) throw new Error("Protocol ".concat(url.protocol, " not allowed with this action."));
    };
    /**
     * Get the current codeVerifier or generate a new one
     * @return {string}
     */ PKCE.prototype.getCodeVerifier = function() {
        if (this.codeVerifier === '') this.codeVerifier = this.randomStringFromStorage('pkce_code_verifier');
        return this.codeVerifier;
    };
    /**
     * Get the current state or generate a new one
     * @return {string}
     */ PKCE.prototype.getState = function(explicit) {
        if (explicit === void 0) explicit = null;
        var stateKey = 'pkce_state';
        if (explicit !== null) this.getStore().setItem(stateKey, explicit);
        if (this.state === '') this.state = this.randomStringFromStorage(stateKey);
        return this.state;
    };
    /**
     * Get the query params as json from a auth response url
     * @param  {string} url a url expected to have AuthResponse params
     * @return {Promise<IAuthResponse>}
     */ PKCE.prototype.parseAuthResponseUrl = function(url) {
        var params = new URL(url).searchParams;
        return this.validateAuthResponse({
            error: params.get('error'),
            query: params.get('query'),
            state: params.get('state'),
            code: params.get('code')
        });
    };
    /**
     * Generate a code challenge
     * @return {Promise<string>}
     */ PKCE.prototype.pkceChallengeFromVerifier = function() {
        var hashed = (0, $37d42502796493b4$var$sha256_1.default)(this.getCodeVerifier());
        return $37d42502796493b4$var$enc_base64_1.default.stringify(hashed).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
    };
    /**
     * Get a random string from storage or store a new one and return it's value
     * @param  {string} key
     * @return {string}
     */ PKCE.prototype.randomStringFromStorage = function(key) {
        var fromStorage = this.getStore().getItem(key);
        if (fromStorage === null) this.getStore().setItem(key, $37d42502796493b4$var$lib_typedarrays_1.default.random(64));
        return this.getStore().getItem(key) || '';
    };
    /**
     * Validates params from auth response
     * @param  {AuthResponse} queryParams
     * @return {Promise<IAuthResponse>}
     */ PKCE.prototype.validateAuthResponse = function(queryParams) {
        var _this = this;
        return new Promise(function(resolve, reject) {
            if (queryParams.error) return reject({
                error: queryParams.error
            });
            if (queryParams.state !== _this.getState()) return reject({
                error: 'Invalid State'
            });
            return resolve(queryParams);
        });
    };
    /**
     * Get the storage (sessionStorage / localStorage) to use, defaults to sessionStorage
     * @return {Storage}
     */ PKCE.prototype.getStore = function() {
        var _a;
        return ((_a = this.config) === null || _a === void 0 ? void 0 : _a.storage) || sessionStorage;
    };
    return PKCE;
}();
$37d42502796493b4$exports.default = $37d42502796493b4$var$PKCE;


class $968f28756c67bd23$export$b9721ef022f71a68 extends Error {
}
$968f28756c67bd23$export$b9721ef022f71a68.prototype.name = "InvalidTokenError";
function $968f28756c67bd23$var$b64DecodeUnicode(str) {
    return decodeURIComponent(atob(str).replace(/(.)/g, (m, p)=>{
        let code = p.charCodeAt(0).toString(16).toUpperCase();
        if (code.length < 2) code = "0" + code;
        return "%" + code;
    }));
}
function $968f28756c67bd23$var$base64UrlDecode(str) {
    let output = str.replace(/-/g, "+").replace(/_/g, "/");
    switch(output.length % 4){
        case 0:
            break;
        case 2:
            output += "==";
            break;
        case 3:
            output += "=";
            break;
        default:
            throw new Error("base64 string is not of the correct length");
    }
    try {
        return $968f28756c67bd23$var$b64DecodeUnicode(output);
    } catch (err) {
        return atob(output);
    }
}
function $968f28756c67bd23$export$fa1e2fb699b7861e(token, options) {
    if (typeof token !== "string") throw new $968f28756c67bd23$export$b9721ef022f71a68("Invalid token specified: must be a string");
    options || (options = {});
    const pos = options.header === true ? 0 : 1;
    const part = token.split(".")[pos];
    if (typeof part !== "string") throw new $968f28756c67bd23$export$b9721ef022f71a68(`Invalid token specified: missing part #${pos + 1}`);
    let decoded;
    try {
        decoded = $968f28756c67bd23$var$base64UrlDecode(part);
    } catch (e) {
        throw new $968f28756c67bd23$export$b9721ef022f71a68(`Invalid token specified: invalid base64 for part #${pos + 1} (${e.message})`);
    }
    try {
        return JSON.parse(decoded);
    } catch (e) {
        throw new $968f28756c67bd23$export$b9721ef022f71a68(`Invalid token specified: invalid json for part #${pos + 1} (${e.message})`);
    }
}


function $7fdd27308359aca4$var$generateRandomState() {
    const array = new Uint8Array(16);
    if (typeof window !== 'undefined' && window.crypto && window.crypto.getRandomValues) window.crypto.getRandomValues(array);
    else if (typeof $parcel$global !== 'undefined' && $parcel$global.crypto && $parcel$global.crypto.getRandomValues) $parcel$global.crypto.getRandomValues(array);
    else // Fallback for test environments - this should not be used in production
    for(let i = 0; i < array.length; i++)array[i] = Math.floor(Math.random() * 256);
    return Array.from(array, (byte)=>byte.toString(16).padStart(2, '0')).join('');
}
class $7fdd27308359aca4$var$Sdk {
    constructor(config){
        this.config = config;
        if (config.redirectPath === undefined || config.redirectPath === null) this.config.redirectPath = "/callback";
        if (config.scope === undefined || config.scope === null) this.config.scope = "profile";
        this.pkce = new (0, (/*@__PURE__*/$parcel$interopDefault($37d42502796493b4$exports)))({
            client_id: this.config.clientId,
            redirect_uri: `${window.location.origin}${this.config.redirectPath}`,
            authorization_endpoint: `${this.config.serverUrl.trim()}/login/oauth/authorize`,
            token_endpoint: `${this.config.serverUrl.trim()}/api/login/oauth/access_token`,
            requested_scopes: this.config.scope || "profile",
            storage: this.config.storage
        });
    }
    getOrSaveState() {
        const state = sessionStorage.getItem("casdoor-state");
        if (state !== null) return state;
        else {
            const state = $7fdd27308359aca4$var$generateRandomState();
            sessionStorage.setItem("casdoor-state", state);
            return state;
        }
    }
    clearState() {
        sessionStorage.removeItem("casdoor-state");
    }
    getSignupUrl(enablePassword = true) {
        if (enablePassword) {
            sessionStorage.setItem("signinUrl", this.getSigninUrl());
            return `${this.config.serverUrl.trim()}/signup/${this.config.appName}`;
        } else return this.getSigninUrl().replace("/login/oauth/authorize", "/signup/oauth/authorize");
    }
    getSigninUrl() {
        const redirectUri = this.config.redirectPath && this.config.redirectPath.includes('://') ? this.config.redirectPath : `${window.location.origin}${this.config.redirectPath}`;
        const state = this.getOrSaveState();
        return `${this.config.serverUrl.trim()}/login/oauth/authorize?client_id=${this.config.clientId}&response_type=code&redirect_uri=${encodeURIComponent(redirectUri)}&scope=${this.config.scope}&state=${state}`;
    }
    getUserProfileUrl(userName, account) {
        let param = "";
        if (account !== undefined && account !== null) param = `?access_token=${account.accessToken}`;
        return `${this.config.serverUrl.trim()}/users/${this.config.organizationName}/${userName}${param}`;
    }
    getMyProfileUrl(account, returnUrl = "") {
        let params = "";
        if (account !== undefined && account !== null) {
            params = `?access_token=${account.accessToken}`;
            if (returnUrl !== "") params += `&returnUrl=${returnUrl}`;
        } else if (returnUrl !== "") params = `?returnUrl=${returnUrl}`;
        return `${this.config.serverUrl.trim()}/account${params}`;
    }
    async signin(serverUrl, signinPath, code, state) {
        if (!code || !state) {
            const params = new URLSearchParams(window.location.search);
            code = params.get("code");
            state = params.get("state");
        }
        const expectedState = this.getOrSaveState();
        this.clearState();
        if (state !== expectedState) return new Promise((resolve, reject)=>{
            setTimeout(()=>{
                resolve({
                    // @ts-ignore
                    status: "error",
                    msg: `invalid state parameter, expected: ${expectedState}, got: ${state}`
                });
            }, 10);
        });
        return fetch(`${serverUrl}${signinPath || this.config.signinPath || '/api/signin'}?code=${code}&state=${state}`, {
            method: "POST",
            credentials: "include"
        }).then((res)=>res.json());
    }
    isSilentSigninRequested() {
        const params = new URLSearchParams(window.location.search);
        return params.get("silentSignin") === "1";
    }
    silentSignin(onSuccess, onFailure) {
        const iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.src = `${this.getSigninUrl()}&silentSignin=1`;
        const handleMessage = (event)=>{
            if (window !== window.parent) return null;
            const message = event.data;
            if (message.tag !== "Casdoor" || message.type !== "SilentSignin") return;
            if (message.data === 'success') onSuccess(message);
            else onFailure(message);
        };
        window.addEventListener('message', handleMessage);
        document.body.appendChild(iframe);
    }
    async popupSignin(serverUrl, signinPath, callback, popupType = "window") {
        const width = 500;
        const height = 600;
        const left = window.screen.width / 2 - width / 2;
        const top = window.screen.height / 2 - height / 2;
        const signinUrl = `${this.getSigninUrl()}&popup=1&popup_type=${popupType}`;
        const popupWindow = popupType === "window" ? window.open(signinUrl, "login", `width=${width},height=${height},top=${top},left=${left}`) : null;
        let iframeMask = null;
        if (popupType === "iframe") {
            iframeMask = document.createElement("div");
            iframeMask.style.position = "fixed";
            iframeMask.style.top = "0";
            iframeMask.style.left = "0";
            iframeMask.style.width = "100vw";
            iframeMask.style.height = "100vh";
            iframeMask.style.background = "rgba(0, 0, 0, 0.55)";
            iframeMask.style.display = "flex";
            iframeMask.style.alignItems = "center";
            iframeMask.style.justifyContent = "center";
            iframeMask.style.zIndex = "2147483647";
            const frameWrapper = document.createElement("div");
            frameWrapper.style.display = "flex";
            frameWrapper.style.flexDirection = "column";
            frameWrapper.style.alignItems = "center";
            frameWrapper.style.gap = "16px";
            const iframe = document.createElement("iframe");
            iframe.src = signinUrl;
            iframe.style.width = `${width}px`;
            iframe.style.height = `${height}px`;
            iframe.style.border = "none";
            iframe.style.borderRadius = "8px";
            iframe.style.background = "#fff";
            const closeButton = document.createElement("button");
            closeButton.type = "button";
            closeButton.innerText = "\xd7";
            closeButton.style.width = "36px";
            closeButton.style.height = "36px";
            closeButton.style.borderRadius = "18px";
            closeButton.style.border = "none";
            closeButton.style.cursor = "pointer";
            closeButton.style.background = "#fff";
            closeButton.style.color = "#333";
            closeButton.style.fontSize = "20px";
            closeButton.style.lineHeight = "36px";
            closeButton.style.padding = "0";
            frameWrapper.appendChild(iframe);
            frameWrapper.appendChild(closeButton);
            iframeMask.appendChild(frameWrapper);
            document.body.appendChild(iframeMask);
            closeButton.onclick = ()=>{
                cleanUp();
                if (callback) callback("login failed");
            };
        }
        const cleanUp = ()=>{
            window.removeEventListener("message", handleMessage);
            if (popupWindow) popupWindow.close();
            if (iframeMask) {
                iframeMask.remove();
                iframeMask = null;
            }
        };
        const handleMessage = (event)=>{
            if (event.origin !== this.config.serverUrl) return;
            if (event.data.type === "windowClosed") {
                if (callback) callback("login failed");
                cleanUp();
            }
            if (event.data.type === "loginSuccess") this.signin(serverUrl, signinPath, event.data.data.code, event.data.data.state).then((res)=>{
                sessionStorage.setItem("token", res.token);
                cleanUp();
                window.location.reload();
            }).catch((error)=>{
                cleanUp();
                if (callback) callback(error);
            });
        };
        window.addEventListener("message", handleMessage);
    }
    async signin_redirect(additionalParams) {
        window.location.assign(this.pkce.authorizeUrl(additionalParams));
    }
    async exchangeForAccessToken(additionalParams) {
        return this.pkce.exchangeForAccessToken(window.location.href, additionalParams);
    }
    async getUserInfo(accessToken) {
        return fetch(`${this.config.serverUrl.trim()}/api/userinfo`, {
            method: "GET",
            headers: {
                "Authorization": `Bearer ${accessToken}`,
                "Content-Type": "application/json"
            }
        }).then((res)=>res.json());
    }
    parseAccessToken(accessToken) {
        try {
            const parsedHeader = (0, $968f28756c67bd23$export$fa1e2fb699b7861e)(accessToken, {
                header: true
            });
            const parsedPayload = (0, $968f28756c67bd23$export$fa1e2fb699b7861e)(accessToken);
            return {
                header: parsedHeader,
                payload: parsedPayload
            };
        } catch (error) {
            throw new Error(error.message);
        }
    }
    refreshAccessToken(refreshToken) {
        return this.pkce.refreshAccessToken(refreshToken);
    }
}
var $7fdd27308359aca4$export$2e2bcd8739ae039 = $7fdd27308359aca4$var$Sdk;


var $2d70d08be8965972$export$2e2bcd8739ae039 = (0, $7fdd27308359aca4$export$2e2bcd8739ae039);


window.baseUrl = "";
window.assetsBaseUrl = "https://iam.tirtapatriot.co/";
const $35da740d59af89ba$var$sdkConfig = {
    serverUrl: "https://sso.tirtapatriot.co",
    clientId: "18cb791475e98ed8cb06",
    organizationName: "tirta-patriot",
    appName: "portal",
    redirectPath: "/"
};
const $35da740d59af89ba$var$sdk = new (0, $2d70d08be8965972$export$2e2bcd8739ae039)($35da740d59af89ba$var$sdkConfig);
function $35da740d59af89ba$var$getIconifyName(faClass) {
    if (!faClass) return '';
    if (faClass.includes(':')) return faClass;
    const parts = faClass.split(/\s+/);
    let prefix = 'fa6-solid';
    let name = '';
    for (const part of parts){
        if (part === 'fa-regular' || part === 'far') prefix = 'fa6-regular';
        else if (part === 'fa-brands' || part === 'fab') prefix = 'fa6-brands';
        else if (part === 'fa-solid' || part === 'fas') prefix = 'fa6-solid';
        else if (part.startsWith('fa-')) name = part.slice(3);
    }
    return name ? `${prefix}:${name}` : faClass;
}
let $35da740d59af89ba$var$applications = [];
let $35da740d59af89ba$var$currentFilter = 'semua';
let $35da740d59af89ba$var$currentSearch = '';
let $35da740d59af89ba$var$searchDebounceTimer = null;
const $35da740d59af89ba$var$loginView = document.getElementById('login-view');
const $35da740d59af89ba$var$dashboardView = document.getElementById('dashboard-view');
const $35da740d59af89ba$var$userProfileName = document.getElementById('userProfileName');
function $35da740d59af89ba$var$mapApiResponseToSections(apiApps) {
    const categories = {
        "administrasi": {
            section: "Adm Umum dan Keuangan",
            deskripsi: "Tata kelola, kepegawaian, anggaran dan pelaporan internal",
            category: "administrasi",
            isMobileSection: false,
            apps: []
        },
        "pelayanan": {
            section: "Operasional & Pelayanan",
            deskripsi: "Pelayanan pelanggan, bacameter, billing dan kanal komunikasi",
            category: "pelayanan",
            isMobileSection: false,
            apps: []
        }
    };
    apiApps.forEach((item)=>{
        let linkLogin = item.link_login || '';
        const app = {
            name: item.nama,
            description: item.deskripsi,
            icon: item.icon,
            logo: item.logo,
            url: linkLogin,
            mobile: item.is_mobile === "1" || item.is_mobile === 1
        };
        const cat = item.category || "administrasi";
        if (!categories[cat]) categories[cat] = {
            section: cat.charAt(0).toUpperCase() + cat.slice(1),
            deskripsi: "",
            category: cat,
            isMobileSection: false,
            apps: []
        };
        categories[cat].apps.push(app);
    });
    return Object.values(categories).filter((section)=>section.apps.length > 0);
}
async function $35da740d59af89ba$var$fetchApplications(userId) {
    try {
        const appListPath = "/panel/portal/app-list";
        const cleanPath = appListPath.startsWith('/') ? appListPath.slice(1) : appListPath;
        const response = await fetch(`${window.baseUrl}${cleanPath}?id_user=${userId}`);
        if (!response.ok) throw new Error('Network response was not ok');
        const json = await response.json();
        if (json && Array.isArray(json.data)) {
            if (json.data.length > 0 && json.data[0].display_name && $35da740d59af89ba$var$userProfileName) $35da740d59af89ba$var$userProfileName.textContent = json.data[0].display_name;
            $35da740d59af89ba$var$applications = $35da740d59af89ba$var$mapApiResponseToSections(json.data);
            const filterTabBar = document.getElementById('filterTabBar');
            if (filterTabBar) {
                if (json.data.length > 8) filterTabBar.classList.remove('hidden');
                else filterTabBar.classList.add('hidden');
            }
            $35da740d59af89ba$var$renderApps();
        }
    } catch (error) {
        console.error("Failed to fetch applications:", error);
        $35da740d59af89ba$var$applications = [];
        $35da740d59af89ba$var$renderApps();
    }
}
const $35da740d59af89ba$var$urlParams = new URLSearchParams(window.location.search);
const $35da740d59af89ba$var$hashParams = new URLSearchParams(window.location.hash.substring(1));
const $35da740d59af89ba$var$token = $35da740d59af89ba$var$urlParams.get('access_token') || $35da740d59af89ba$var$urlParams.get('id_token') || $35da740d59af89ba$var$urlParams.get('token') || $35da740d59af89ba$var$hashParams.get('access_token') || $35da740d59af89ba$var$hashParams.get('id_token') || $35da740d59af89ba$var$hashParams.get('token');
const $35da740d59af89ba$var$code = $35da740d59af89ba$var$urlParams.get('code') || $35da740d59af89ba$var$hashParams.get('code');
const $35da740d59af89ba$var$authError = $35da740d59af89ba$var$urlParams.get('error') || $35da740d59af89ba$var$urlParams.get('auth_error');
const $35da740d59af89ba$var$authErrorDesc = $35da740d59af89ba$var$urlParams.get('error_description') || $35da740d59af89ba$var$urlParams.get('msg');
if ($35da740d59af89ba$var$authError) {
    if ($35da740d59af89ba$var$dashboardView) $35da740d59af89ba$var$dashboardView.classList.add('hidden');
    if ($35da740d59af89ba$var$loginView) $35da740d59af89ba$var$loginView.classList.remove('hidden');
    const errorEl = document.getElementById('authErrorMsg');
    const errorTextEl = document.getElementById('authErrorText');
    if (errorEl && errorTextEl) {
        errorTextEl.textContent = $35da740d59af89ba$var$authErrorDesc || ($35da740d59af89ba$var$authError ? `Auth Error: ${$35da740d59af89ba$var$authError}` : "Gagal melakukan verifikasi akun.");
        errorEl.classList.remove('hidden');
    }
    window.history.replaceState({}, document.title, window.location.pathname);
} else if ($35da740d59af89ba$var$token) {
    try {
        const parsed = $35da740d59af89ba$var$sdk.parseAccessToken($35da740d59af89ba$var$token);
        const payload = parsed ? parsed.payload : null;
        if (payload) localStorage.setItem('user', JSON.stringify({
            name: payload.displayName || payload.name,
            role: payload.role || 'User',
            id: payload.id || payload.sub,
            avatar: payload.avatar || ''
        }));
    } catch (e) {
        console.error("Failed to parse token:", e);
    }
    window.location.href = window.location.origin + window.location.pathname;
} else if ($35da740d59af89ba$var$code) {
    if ($35da740d59af89ba$var$loginView) $35da740d59af89ba$var$loginView.classList.add('hidden');
    if ($35da740d59af89ba$var$dashboardView) $35da740d59af89ba$var$dashboardView.classList.add('hidden');
    $35da740d59af89ba$var$sdk.exchangeForAccessToken().then((tokenRes)=>{
        const accessToken = tokenRes.access_token || tokenRes.id_token;
        if (accessToken) {
            const parsed = $35da740d59af89ba$var$sdk.parseAccessToken(accessToken);
            const payload = parsed ? parsed.payload : null;
            if (payload) localStorage.setItem('user', JSON.stringify({
                name: payload.displayName || payload.name,
                role: payload.role || 'User',
                id: payload.id || payload.sub,
                avatar: payload.avatar || ''
            }));
        }
        window.location.href = window.location.origin + window.location.pathname;
    }).catch((err)=>{
        console.error("Failed to exchange code:", err);
        window.location.href = window.location.origin + window.location.pathname + `?auth_error=exchange_failed&msg=${encodeURIComponent(err.message || 'Gagal menukarkan kode otorisasi.')}`;
    });
} else {
    const user = JSON.parse(localStorage.getItem('user'));
    if (user) {
        if ($35da740d59af89ba$var$loginView) $35da740d59af89ba$var$loginView.classList.add('hidden');
        if ($35da740d59af89ba$var$dashboardView) $35da740d59af89ba$var$dashboardView.classList.remove('hidden');
        if ($35da740d59af89ba$var$userProfileName) $35da740d59af89ba$var$userProfileName.textContent = user.name;
        const avatarWrap = document.getElementById('userProfileAvatarWrap');
        if (avatarWrap && user.avatar) avatarWrap.innerHTML = `<img src="${user.avatar}" class="w-full h-full object-cover rounded-full" alt="${user.name}">`;
        $35da740d59af89ba$var$initSearch();
        const userId = user.id || "5a1836a8-dc81-4efb-ae26-22697ecb0a39";
        $35da740d59af89ba$var$fetchApplications(userId);
    } else {
        if ($35da740d59af89ba$var$dashboardView) $35da740d59af89ba$var$dashboardView.classList.add('hidden');
        if ($35da740d59af89ba$var$loginView) $35da740d59af89ba$var$loginView.classList.remove('hidden');
    }
}
const $35da740d59af89ba$var$btnLoginSSO = document.getElementById('btnLoginSSO');
if ($35da740d59af89ba$var$btnLoginSSO) $35da740d59af89ba$var$btnLoginSSO.addEventListener('click', ()=>{
    $35da740d59af89ba$var$sdk.signin_redirect();
});
const $35da740d59af89ba$var$btnLogout = document.getElementById("btnLogout");
if ($35da740d59af89ba$var$btnLogout) $35da740d59af89ba$var$btnLogout.addEventListener("click", function(e) {
    e.preventDefault();
    localStorage.removeItem('user');
    const redirectUrl = window.location.origin + window.location.pathname;
    const casdoorLogoutUrl = `${$35da740d59af89ba$var$sdkConfig.serverUrl}/api/logout?post_logout_redirect_uri=${encodeURIComponent(redirectUrl)}`;
    window.location.href = casdoorLogoutUrl;
});
document.addEventListener('click', function(e) {
    const wrap = document.getElementById('userDropdownWrap');
    if (wrap && !wrap.contains(e.target)) {
        const menu = document.getElementById('userMenu');
        if (menu) menu.classList.add('hidden');
    }
});
function $35da740d59af89ba$var$renderApps(filterCategory = $35da740d59af89ba$var$currentFilter) {
    $35da740d59af89ba$var$currentFilter = filterCategory;
    document.querySelectorAll('.filter-tab').forEach((tab)=>{
        tab.className = 'filter-tab px-4 py-2 rounded-2xl text-sm font-semibold transition-all duration-200 cursor-pointer text-gray-500 hover:text-gray-900 hover:bg-gray-50';
    });
    const activeTab = document.getElementById(`tab-${filterCategory}`);
    if (activeTab) activeTab.className = 'filter-tab px-4 py-2 rounded-2xl text-sm font-semibold transition-all duration-200 cursor-pointer bg-blue-600 text-white shadow-md shadow-blue-500/10 active';
    const appContainer = document.getElementById('app-content');
    if (!appContainer) return;
    appContainer.innerHTML = '';
    const filteredSections = $35da740d59af89ba$var$currentFilter === 'semua' ? $35da740d59af89ba$var$applications : $35da740d59af89ba$var$applications.filter((s)=>s.category === $35da740d59af89ba$var$currentFilter);
    const searchedSections = filteredSections.map((section)=>({
            ...section,
            apps: section.apps.filter((app)=>{
                if ($35da740d59af89ba$var$currentSearch) return app.name.toLowerCase().includes($35da740d59af89ba$var$currentSearch);
                return true;
            })
        })).filter((section)=>section.apps.length > 0);
    searchedSections.forEach((section, sIdx)=>{
        const sectionEl = $35da740d59af89ba$var$createSectionElement(section, sIdx, searchedSections.length);
        appContainer.appendChild(sectionEl);
    });
}
function $35da740d59af89ba$var$createSectionElement(section, index, totalSections) {
    const div = document.createElement('div');
    div.className = $35da740d59af89ba$var$currentSearch ? '' : 'app-section-anim';
    if (index === totalSections - 1) div.style.marginBottom = '0';
    if (!$35da740d59af89ba$var$currentSearch) div.style.animationDelay = `${0.1 + index * 0.08}s`;
    const activeCount = section.apps.length;
    div.innerHTML = `
        <div class="portal-section-header">
            <div>
                <div class="portal-section-title-row">
                    <h2 class="portal-section-title">
                        ${section.section}
                    </h2>
                    ${section.isMobileSection ? `<span class="badge-apk">${section.tag}</span>` : ''}
                </div>
                <p class="portal-section-desc">
                    ${section.deskripsi || ''}
                </p>
            </div>
            <span class="portal-section-count">
                ${activeCount} APLIKASI
            </span>
        </div>
        <div class="app-grid">
            ${section.apps.map((app, aIdx)=>$35da740d59af89ba$var$createAppCardHtml(app, section, index, aIdx)).join('')}
        </div>
    `;
    return div;
}
function $35da740d59af89ba$var$escapeHtmlAttribute(value) {
    return String(value).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}
function $35da740d59af89ba$var$createAppCardHtml(app, section, sIdx, aIdx) {
    const isActive = true;
    const delay = (0.15 + sIdx * 0.08 + aIdx * 0.06).toFixed(2);
    let url = app.url || '';
    const isMobile = app.mobile;
    const btnLabel = isMobile ? 'Unduh Aplikasi' : 'Masuk Aplikasi';
    const onclickAction = isActive && url ? isMobile ? `onclick="downloadFile('${url}')"` : `onclick="event.preventDefault(); window.open('${url}', '_self')"` : '';
    const hasLogo = app.logo && app.logo !== '';
    const escapedDesc = $35da740d59af89ba$var$escapeHtmlAttribute(app.description || '');
    const logoBaseUrl = window.assetsBaseUrl;
    return `
        <a
            href="${url}"
            class="card-link"
            ${onclickAction}
        >
            <div
                class="app-card ${$35da740d59af89ba$var$currentSearch ? '' : 'app-card-anim'}"
                style="
                    ${$35da740d59af89ba$var$currentSearch ? '' : `animation-delay:${delay}s;`}
                    opacity:${isActive ? '1' : '.5'};
                    cursor:${isActive ? 'pointer' : 'not-allowed'};
                "
            >

                <div class="app-card-body">
                    <div class="app-icon-box">
                        ${hasLogo ? `
                                    <img
                                        src="${logoBaseUrl}assets/images/logo/${app.logo}"
                                        alt="${app.name}"
                                        class="app-logo"
                                    >
                                ` : `
                                     <iconify-icon
                                         icon="${$35da740d59af89ba$var$getIconifyName(app.icon)}"
                                         width="28"
                                         height="28"
                                         style="color:#0c4da2;"
                                     ></iconify-icon>
                                 `}
                    </div>

                    <div class="app-title">
                        ${app.name}
                    </div>

                    <div class="app-desc" title="${escapedDesc}">
                        ${app.description || ''}
                    </div>
                </div>

                <div class="app-card-footer">
                    <span>${btnLabel}</span>

                    <iconify-icon
                        icon="fa6-solid:arrow-right"
                        style="font-size:13px;"
                    ></iconify-icon>
                </div>

            </div>
        </a>
    `;
}
function $35da740d59af89ba$var$initSearch() {
    const searchInput = document.getElementById('searchInput');
    const clearSearch = document.getElementById('clearSearch');
    if (!searchInput) return;
    searchInput.addEventListener('input', function() {
        const val = this.value.trim();
        if (clearSearch) {
            if (val) clearSearch.classList.remove('hidden');
            else clearSearch.classList.add('hidden');
        }
        clearTimeout($35da740d59af89ba$var$searchDebounceTimer);
        $35da740d59af89ba$var$searchDebounceTimer = setTimeout(()=>{
            $35da740d59af89ba$var$currentSearch = val.toLowerCase();
            $35da740d59af89ba$var$renderApps($35da740d59af89ba$var$currentFilter);
        }, 300);
    });
    if (clearSearch) clearSearch.addEventListener('click', ()=>{
        searchInput.value = '';
        $35da740d59af89ba$var$currentSearch = '';
        clearSearch.classList.add('hidden');
        $35da740d59af89ba$var$renderApps($35da740d59af89ba$var$currentFilter);
        searchInput.focus();
    });
}
function $35da740d59af89ba$var$downloadFile(url) {
    const a = document.createElement('a');
    a.href = url;
    a.download = '';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
}
window.downloadFile = $35da740d59af89ba$var$downloadFile;
window.renderApps = $35da740d59af89ba$var$renderApps;
var $129d2eddeeb40f93$exports = {};
$129d2eddeeb40f93$exports = import.meta.resolve("kLn2N");


if ('serviceWorker' in navigator) {
    window.addEventListener('load', ()=>{
        navigator.serviceWorker.register($129d2eddeeb40f93$exports).then((reg)=>{
            console.log('Service Worker registered successfully:', reg.scope);
            // Cek update baru setiap 30 detik
            setInterval(()=>{
                reg.update();
            }, 30000);
        }).catch((err)=>console.error('Service Worker registration failed:', err));
    });
    // Reload halaman otomatis saat service worker baru mengambil alih
    let refreshing = false;
    navigator.serviceWorker.addEventListener('controllerchange', ()=>{
        if (refreshing) return;
        refreshing = true;
        window.location.reload();
    });
}


//# sourceMappingURL=app.16a55fc9.js.map
